import type { CrmMessages } from "./englishCrmMessages";

export const spanishCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre de la empresa",
        website: "Sitio web",
        linkedin_url: "URL de LinkedIn",
        phone_number: "Teléfono",
        created_at: "Fecha de creación",
        nb_contacts: "Número de contactos",
        revenue: "Ingresos",
        sector: "Sector",
        size: "Tamaño",
        tax_identifier: "RFC",
        address: "Dirección",
        city: "Ciudad",
        zipcode: "Código postal",
        state_abbr: "Estado",
        country: "País",
        description: "Descripción",
        context_links: "Enlaces de contexto",
        sales_id: "Responsable de la cuenta",
      },
      empty: {
        description: "Parece que tu lista de empresas está vacía.",
        title: "No se encontraron empresas",
      },
      import: {
        title: "Importar empresas",
      },
      field_categories: {
        contact: "Contacto",
        additional_info: "Información adicional",
        address: "Dirección",
        context: "Contexto",
      },
      action: {
        create: "Crear empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
        show: "Ver empresa",
      },
      added_on: "Agregada el %{date}",
      followed_by: "Seguida por %{name}",
      followed_by_you: "Seguida por ti",
      no_contacts: "Sin contactos",
      nb_contacts: "%{smart_count} contacto |||| %{smart_count} contactos",
      nb_deals: "%{smart_count} lead |||| %{smart_count} leads",
      sizes: {
        one_employee: "1 empleado",
        two_to_nine_employees: "2-9 empleados",
        ten_to_forty_nine_employees: "10-49 empleados",
        fifty_to_two_hundred_forty_nine_employees: "50-249 empleados",
        two_hundred_fifty_or_more_employees: "250 empleados o más",
      },
      autocomplete: {
        create_error: "Ocurrió un error al crear la empresa",
        create_item: "Crear %{item}",
        create_label: "Empieza a escribir para crear una nueva empresa",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Antecedentes",
        classification: "Clasificación",
        identity: "Identidad",
        misc: "Otros",
        personal_info: "Información personal",
        position: "Puesto",
      },
      // Almikia Epic EC2a (TASK-120): una sola agenda, once tipos de contacto.
      contact_types: {
        lead_buyer: "Lead comprador",
        lead_tenant: "Lead inquilino",
        client: "Cliente",
        tenant: "Arrendatario",
        guarantor: "Aval / obligado solidario",
        owner_seller: "Propietario vendedor",
        owner_lessor: "Propietario arrendador",
        colega: "Colega",
        supplier: "Proveedor",
        ally: "Aliado",
        developer: "Desarrollador",
      },
      affiliation_required: "Elige la afiliación del colega",
      types_placeholder: "Elige los tipos de contacto",
      types_selected:
        "%{smart_count} tipo elegido |||| %{smart_count} tipos elegidos",
      colega_kinds: {
        independiente: "Independiente",
        inmobiliaria: "Inmobiliaria",
      },
      colega_affiliations: {
        ampi: "AMPI",
        otra: "Otra",
        ninguna: "Ninguna",
      },
      agreement: {
        yes: "Sí",
        no: "No",
      },
      business_units: {
        corretaje: "Corretaje",
        bpo: "BPO",
      },
      supplier_category: {
        create_item: "Crear categoría %{item}",
        create_label: "Crear categoría",
        create_error: "No se pudo crear la categoría",
      },
      name_review: {
        badge: "Revisar nombre",
        mark_reviewed: "Marcar como revisado",
      },
      fields: {
        first_name: "Nombre(s)",
        last_name: "Apellido paterno",
        second_last_name: "Apellido materno",
        contact_types: "Tipo de contacto",
        lead_source_id: "Origen",
        referred_by_contact_id: "Referido por",
        origin_colega_contact_id: "Colega de origen",
        business_unit: "Unidad de negocio",
        business_project_id: "Proyecto",
        colega_kind: "Tipo de colega",
        colega_affiliation: "Afiliación",
        colega_agreement_signed: "Convenio firmado",
        colega_company_id: "Inmobiliaria",
        supplier_category_id: "Categoría del proveedor",
        guarantor_of_contact_id: "Inquilino al que avala",
        tags: "Etiquetas",
        last_seen: "Última actividad",
        title: "Puesto",
        company_id: "Empresa",
        email_jsonb: "Correos electrónicos",
        email: "Correo electrónico",
        phone_jsonb: "Teléfonos",
        phone_number: "Teléfono",
        linkedin_url: "URL de LinkedIn",
        background: "Antecedentes (bio, cómo se conocieron, etc.)",
        has_newsletter: "Suscrito al boletín",
        sales_id: "Responsable de la cuenta",
      },
      action: {
        add: "Agregar contacto",
        add_first: "Agrega tu primer contacto",
        create: "Crear contacto",
        edit: "Editar contacto",
        export_vcard: "Exportar a vCard",
        new: "Nuevo contacto",
        show: "Ver contacto",
      },
      background: {
        last_activity_on: "Última actividad el %{date}",
        added_on: "Agregado el %{date}",
        followed_by: "Seguido por %{name}",
        followed_by_you: "Seguido por ti",
        status_none: "Ninguno",
      },
      position_at: "%{title} en",
      position_at_company: "%{title} en %{company}",
      empty: {
        description: "Parece que tu lista de contactos está vacía.",
        title: "No se encontraron contactos",
      },
      import: {
        title: "Importar contactos",
      },
      inputs: {
        genders: {
          male: "Él",
          female: "Ella",
          nonbinary: "Otro",
        },
        personal_info_types: {
          work: "Trabajo",
          home: "Casa",
          other: "Otro",
        },
      },
      list: {
        error_loading: "Error al cargar los contactos",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Volver a etiquetas",
        create_description:
          "Crea una nueva etiqueta y aplícala a los contactos seleccionados.",
        description:
          "Elige una etiqueta existente o crea una nueva para los contactos seleccionados.",
        empty:
          "Aún no hay etiquetas. Crea una para etiquetar los contactos seleccionados.",
        error: "No se pudo agregar la etiqueta a los contactos",
        noop: "Los contactos seleccionados ya tienen esta etiqueta",
        success:
          "Etiqueta agregada a %{smart_count} contacto |||| Etiqueta agregada a %{smart_count} contactos",
        title: "Agregar etiqueta a contactos",
      },
      merge: {
        action: "Combinar con otro contacto",
        confirm: "Combinar contactos",
        current_contact: "Contacto actual (se eliminará)",
        description: "Combina este contacto con otro.",
        error: "No se pudieron combinar los contactos",
        merging: "Combinando...",
        no_additional_data: "No hay datos adicionales para combinar",
        select_target: "Selecciona un contacto con el cual combinar",
        success: "Contactos combinados correctamente",
        target_contact: "Contacto destino (se conservará)",
        title: "Combinar contacto",
        warning_description:
          "Todos los datos se transferirán al segundo contacto. Esta acción no se puede deshacer.",
        warning_title: "Advertencia: operación destructiva",
        what_will_be_merged: "Qué se combinará:",
      },
      filters: {
        before_last_month: "Antes del mes pasado",
        before_this_month: "Antes de este mes",
        before_this_week: "Antes de esta semana",
        company: "Empresa",
        managed_by_me: "Gestionados por mí",
        no_type: "Sin tipo",
        search: "Buscar nombre, empresa...",
        this_week: "Esta semana",
        today: "Hoy",
        tags: "Etiquetas",
        tasks: "Tareas",
      },
      hot: {
        empty_change_status:
          'Cambia el estatus de un contacto agregándole una nota y haciendo clic en "mostrar opciones".',
        empty_hint: 'Los contactos con estatus "caliente" aparecerán aquí.',
        title: "Contactos calientes",
      },
    },
    deals: {
      name: "Lead |||| Leads",
      fields: {
        name: "Nombre",
        description: "Descripción",
        company_id: "Empresa",
        contact_ids: "Contactos",
        category: "Categoría",
        amount: "Presupuesto",
        expected_closing_date: "Fecha estimada de cierre",
        stage: "Etapa",
        project_id: "Proyecto",
        client_id: "Cliente",
        lead_type: "Tipo de lead",
        external_broker: "Colega",
        external_broker_legacy: "Colega (texto anterior)",
        colega_id: "Colega",
        source: "Origen",
        source_legacy: "Origen (texto anterior)",
        lead_source_id: "Origen",
        score: "Calificación",
        posi_intent: "Intención",
        // Distinct from `amount` (also "Presupuesto"): the deal budget and
        // the POSI budget answer are different questions shown on the same form.
        posi_budget: "Presupuesto (POSI)",
        posi_payment_method: "Forma de pago",
        posi_decision_maker: "Quién decide",
        // Almikia Epic E3b (TASK-070): the lead reassignment owner picker,
        // shown only to direccion / lead_manager (never asesora or lider).
        sales_id: "Asignado a",
      },
      lead_types: {
        bpo: "BPO",
        proactivo: "Proactivo",
        almikia: "Almikia",
        colega: "Colega",
      },
      // Almikia Epic EL3: plain-language definition of each lead TYPE (who generated the lead).
      lead_type_definitions: {
        bpo: "Lo generó el desarrollador con sus propios esfuerzos.",
        almikia: "Lo generó la inmobiliaria con sus propios esfuerzos.",
        proactivo:
          "Lo generó una asesora, líder o dirección como parte de su cartera.",
        colega:
          "Existe porque un colega inmobiliario lo trae con su propio esfuerzo.",
      },
      protected_no_reassign: "Los leads proactivos y de colega no se reasignan",
      protected_use_action:
        "Este lead es proactivo o de colega. Para cambiar de asesora usa Reasignar (Dirección).",
      owner_auto_hint: "Se asignará automáticamente",
      action: {
        back_to_deal: "Volver al lead",
        create: "Crear lead",
        new: "Nuevo lead",
        // Almikia Epic EA (TASK-111): opens `LogActivityForm` from the lead
        // show.
        log_activity: "Registrar actividad",
      },
      field_categories: {
        misc: "Otros",
        posi: "POSI",
      },
      filters: {
        only_mine: "Solo los leads que gestiono",
      },
      special_states: {
        title: "Otros estados",
        empty: "No hay leads en este estado.",
      },
      prospect_inbox: {
        title: "Prospecto",
        empty: "No hay leads en el buzón de Prospecto.",
        elapsed: "Hace %{hours} h",
        flags: {
          on_time: "A tiempo",
          due_soon: "Por vencer",
          overdue: "Más de 24 h",
        },
      },
      archived: {
        action: "Archivar",
        error: "Error: el lead no se archivó",
        list_title: "Leads archivados",
        success: "Lead archivado",
        title: "Lead archivado",
        view: "Ver leads archivados",
      },
      inputs: {
        linked_to: "Vinculada a",
      },
      unarchived: {
        action: "Regresar al tablero",
        error: "Error: el lead no se desarchivó",
        success: "Lead desarchivado",
      },
      updated: "Lead actualizado",
      empty: {
        before_create: "antes de crear un lead.",
        description: "Parece que tu lista de leads está vacía.",
        title: "No se encontraron leads",
      },
      import: {
        title: "Importar leads",
      },
      invalid_date: "Fecha inválida",
      posi_gate_blocked:
        "Completa las 4 preguntas POSI antes de mover el lead a Showing",
      // Almikia Epic EP (TASK-106): distinct from a lead's own archived
      // state (`archived`/`unarchived` above) -- this marks a STAGE
      // (`deal_stage_configs.archived_at`) that still holds at least one
      // loaded lead, shown on a kanban column or a special-state tab.
      stage_archived_marker: "Etapa archivada",
      stage_empty: "No hay leads en esta etapa. Suelta uno aquí.",
      archived_stage_drop_blocked:
        "Esta etapa está archivada; ya no puede recibir leads nuevos",
      // Almikia Epic EP (TASK-108), DATA CONTRACT EP (9): the readiness
      // pill's two messages -- `%{items}` is already the joined ("a, b y c")
      // Spanish item list from `stageReadiness.ts`, never re-joined here.
      stage_readiness: {
        met: "Ya cumple para %{stage}",
        missing: "Te falta %{items} para %{stage}",
      },
      // Almikia Epic EA (TASK-111), vision #4: "Registrar actividad" -- one
      // form that logs the activity + result + optional note and sets the
      // next-step task in a single save.
      activity_log: {
        title: "Registrar actividad",
        activity_label: "Actividad",
        groups: {
          stage: "De esta etapa",
          other: "Otras actividades",
        },
        result_label: "Resultado",
        message: {
          copy: "Copiar mensaje",
        },
        note_label: "Nota (opcional)",
        empty: "No hay actividades disponibles",
        error_loading: "No se pudieron cargar las actividades",
        save: "Guardar",
        save_error: "No se pudo registrar la actividad",
        success: "Actividad registrada",
        next_step: {
          label: "Siguiente paso: %{activity} · %{date}",
          due_at_label: "Fecha y hora del siguiente paso",
          none: "Sin siguiente paso",
          no_contact:
            "Agrega un contacto a este lead para agendar el siguiente paso",
          attempts_exhausted:
            "Ya se alcanzó el máximo de intentos para el siguiente paso",
          next_activity_archived:
            "La siguiente actividad ya no está disponible",
        },
      },
      next_step: {
        title: "Siguiente paso",
        none: "Sin siguiente paso agendado",
        overdue: "Vencido",
      },
      // Almikia Epic EF (TASK-119), vision #5: "Construir el perfil durante
      // el Discovery con opciones rápidas + notas libres" -- 'Perfil del
      // cliente'. Chip labels and shared guard messages are NOT duplicated
      // here: they already live as Spanish constants in `dealProfile/profileRules.ts`
      // (options/errors shared with the server and FakeRest).
      deal_profile: {
        title: "Perfil del cliente",
        header_count: "%{count} de %{total} datos",
        error_loading: "No se pudo cargar el perfil",
        groups: {
          who: "Quién es",
          looking_for: "Qué busca",
          payment: "Cómo paga",
          timing: "Cuándo y por qué",
        },
        fields: {
          buyer_type: "Tipo de comprador",
          decision_maker: "Quién decide",
          decision_maker_hint: "Se captura en POSI",
          decision_maker_empty: "Sin respuesta",
          sells_other_property: "Vende otra propiedad",
          property_type: "Tipo de propiedad",
          bedrooms: "Recámaras",
          zone: "Zona",
          compared_projects: "Proyectos que compara",
          budget_min: "Presupuesto desde",
          budget_max: "Presupuesto hasta",
          credit_type: "Crédito",
          down_payment: "Enganche",
          monthly_payment: "Mensualidad",
          timeline: "Plazo",
          interest_level: "Interés",
          motivators: "Motivadores",
          objections: "Objeciones",
          notes: "Notas del perfil",
        },
        status: {
          saving: "Guardando…",
          saved: "Guardado hace unos segundos",
          error: "No se pudo guardar. Intenta de nuevo.",
        },
      },
    },
    developers: {
      name: "Desarrolladora |||| Desarrolladoras",
      fields: {
        legal_name: "Razón social",
        rfc: "RFC",
        fiscal_zip_code: "Código postal fiscal",
        tax_regime: "Régimen fiscal",
        cfdi_use: "Uso de CFDI",
        invoice_email: "Correo de facturación",
        authorization_to_sell_status: "Estatus de autorización de venta",
      },
      authorization_to_sell_status: {
        pendiente: "Pendiente",
        validado: "Validado",
      },
      fiscal: {
        title: "Datos fiscales",
        updated: "Datos fiscales actualizados",
        update_error: "Ocurrió un error. Inténtalo de nuevo",
      },
      fiscal_documents: {
        title: "Constancia de Situación Fiscal",
        upload_button: "Subir Constancia",
        upload_success: "Constancia subida correctamente",
        upload_error: "No se pudo subir la Constancia. Inténtalo de nuevo",
        error_invalid_type: "Solo se aceptan archivos PDF",
        error_too_large: "El archivo supera el límite de 10 MB",
        view: "Ver",
        view_error: "No se pudo abrir el documento. Inténtalo de nuevo",
        uploaded_by_unknown: "Usuario desconocido",
        empty: "Aún no se han subido versiones",
      },
      empty: {
        description: "Parece que tu lista de desarrolladoras está vacía.",
        title: "No se encontraron desarrolladoras",
      },
    },
    projects: {
      name: "Proyecto |||| Proyectos",
      fields: {
        name: "Nombre",
        code: "Código",
        developer_id: "Desarrolladora",
        compliance_pack_status: "Estatus del paquete de cumplimiento",
        invoice_concept_template: "Plantilla de concepto de factura",
        invoice_concept_template_version: "Versión de la plantilla",
        archived: "Archivado",
      },
      compliance_pack_status: {
        pendiente: "Pendiente",
        validado: "Validado",
      },
      archived_status: {
        active: "Activo",
        archived: "Archivado",
      },
      empty: {
        description: "Parece que tu lista de proyectos está vacía.",
        title: "No se encontraron proyectos",
      },
    },
    units: {
      name: "Unidad |||| Unidades",
      fields: {
        project_id: "Proyecto",
        identifier: "Identificador",
        type: "Tipo",
        status: "Estatus",
        list_price: "Precio de lista",
      },
      type: {
        depto: "Departamento",
        local: "Local comercial",
        lote: "Lote",
      },
      status: {
        disponible: "Disponible",
        apartada: "Apartada",
        vendida: "Vendida",
      },
    },
    incentive_programs: {
      name: "Incentivo |||| Incentivos",
      fields: {
        name: "Nombre",
        scope: "Alcance",
        period: "Periodo",
        validity: "Vigencia",
        parameters_summary: "Parámetros",
        rate_pct: "Tasa (%)",
        cap_mxn_per_sale: "Tope por venta (MXN)",
        min_level: "Nivel mínimo",
        min_units: "Mínimo de unidades",
        tiers: "Niveles",
        tier_threshold_mxn: "Umbral (MXN)",
        tier_rate_pct: "Tasa del nivel (%)",
        tier_inclusive: "Umbral inclusivo",
        target_appointments: "Meta de citas",
        reward_max_mxn: "Recompensa máxima (MXN)",
        valid_from: "Vigente desde",
        valid_to: "Vigente hasta",
      },
      scope: {
        advisor: "Asesora",
        team: "Equipo",
      },
      period: {
        month: "Mensual",
        quarter: "Trimestral",
        accumulated: "Acumulado",
      },
      validity: {
        open_ended: "Desde %{from}",
        range: "%{from} – %{to}",
      },
      summary: {
        monthly_sale_incentive: "%{rate} % por venta, tope %{cap}",
        quarterly_outstanding_sales:
          "Mínimo %{min_units} unidades, %{tiers_count} niveles de comisión",
        monthly_proactive_appointments:
          "%{target} citas, recompensa máxima %{reward}",
        no_parameters: "Sin parámetros definidos aún",
      },
      no_parameters_yet:
        "Las reglas de este incentivo todavía no están definidas.",
      action: {
        new_vigencia: "Nueva vigencia",
      },
      new_vigencia: {
        title: "Nueva vigencia de %{name}",
        success: "Nueva vigencia creada",
        error: "No se pudo crear la nueva vigencia. Inténtalo de nuevo.",
      },
      empty: {
        title: "No se encontraron incentivos",
        description: "Todavía no hay programas de incentivos configurados.",
      },
    },
    deal_stage_configs: {
      name: "Etapa |||| Etapas",
      title: "Etapas y criterios para avanzar",
      fields: {
        key: "Clave",
        key_help: "La clave no puede modificarse una vez creada la etapa.",
        label: "Nombre",
        placement: "Ubicación",
        target_hours: "Tiempo objetivo",
        required_activities: "Actividades de la etapa",
      },
      group: {
        inbox: "Bandeja",
        kanban: "Tablero",
        special: "Estados especiales",
      },
      system_marker: "Etapa base",
      archived_marker: "Archivada",
      criteria: {
        none: "Sin criterios",
        title: "Criterios para avanzar",
        enabled: "Activado",
        disabled: "Desactivado",
        confirm_off_title: "¿Desactivar este criterio?",
        confirm_off_body:
          "Los leads podrán entrar a esta etapa sin haber respondido las 4 preguntas POSI.",
        confirm_off_action: "Sí, desactivar",
      },
      target_time: {
        none: "Sin tiempo objetivo",
        hours: "%{smart_count} h",
        days: "%{smart_count} día |||| %{smart_count} días",
        unit_hours: "Horas",
        unit_days: "Días",
        help: "Tiempo esperado en esta etapa. Solo informativo por ahora.",
      },
      required_activities: {
        placeholder: "Agregar una actividad y presionar Enter",
        help: "Lista informativa: todavía no se valida ni se bloquea nada con ella.",
        limit: "Hasta %{max} actividades",
      },
      activities: {
        catalogue_title: "Actividades del catálogo",
        empty: "Todavía no hay actividades en el catálogo.",
        none: "Sin actividades",
        archived_marker: "Archivada",
        save_action: "Guardar vínculos",
        saved: "Vínculos de actividades guardados",
        unsaved_links_warning:
          "Tienes vínculos de actividades sin guardar. Guárdalos o descártalos antes de guardar la etapa.",
      },
      alerts: {
        title: "Alertas",
        empty: "Todavía no hay alertas configurables para esta etapa.",
      },
      action: {
        new_stage: "Nueva etapa",
        move_up: "Subir",
        move_down: "Bajar",
        archive: "Archivar",
        reactivate: "Reactivar",
      },
      new_stage: {
        placement_help:
          "Elige si la nueva etapa aparece en el Tablero o como Estado especial.",
      },
      archive: {
        system_reason: "Las etapas base no pueden archivarse.",
        archived: "Etapa archivada",
        reactivated: "Etapa reactivada",
        confirm_archive_title: "¿Archivar esta etapa?",
        confirm_archive_body:
          "Los leads que ya están en esta etapa se quedan ahí. Podrás reactivarla después.",
        confirm_reactivate_title: "¿Reactivar esta etapa?",
        confirm_reactivate_body:
          "La etapa volverá a estar disponible para asignar leads.",
      },
      error: {
        label_required: "El nombre de la etapa es obligatorio",
        label_too_long: "El nombre de la etapa no puede exceder 40 caracteres",
        label_duplicate: "Ya existe una etapa activa con ese nombre",
        activities_too_many: "Puedes agregar hasta 10 actividades",
        activities_invalid:
          "Cada actividad debe tener texto y máximo 80 caracteres",
        target_time_invalid: "El tiempo objetivo debe ser mayor a 0",
        not_authorized: "Solo Dirección puede modificar las etapas",
        generic: "No se pudo guardar el cambio. Inténtalo de nuevo.",
      },
    },
    deal_activity_types: {
      name: "Actividad |||| Actividades",
      title: "Actividades",
      fields: {
        name: "Nombre",
        message_template: "Mensaje",
        message_template_help:
          "Puedes usar {nombre}, {asesora} y {proyecto}; se completan automáticamente al usar el mensaje.",
        message_preview: "Vista previa",
        max_attempts: "Máximo de intentos",
        max_attempts_help:
          "Déjalo vacío si esta actividad no tiene límite de intentos.",
      },
      results_count:
        "%{smart_count} resultado activo |||| %{smart_count} resultados activos",
      cap_label: "Máximo %{max} intentos",
      archived_marker: "Archivada",
      empty: "Todavía no hay actividades en el catálogo.",
      action: {
        new_activity: "Nueva actividad",
        archive: "Archivar",
        reactivate: "Reactivar",
      },
      archive: {
        archived: "Actividad archivada",
        reactivated: "Actividad reactivada",
        confirm_archive_title: "¿Archivar esta actividad?",
        confirm_archive_body:
          "El historial de actividades ya registradas se conserva. La actividad dejará de aparecer para registrar nuevas actividades y como siguiente paso; podrás reactivarla después.",
        confirm_reactivate_title: "¿Reactivar esta actividad?",
        confirm_reactivate_body:
          "La actividad volverá a estar disponible para registrar y como siguiente paso.",
      },
      error: {
        name_required: "El nombre de la actividad es obligatorio",
        name_too_long:
          "El nombre de la actividad no puede exceder 80 caracteres",
        name_duplicate: "Ya existe una actividad activa con ese nombre",
        message_template_too_long:
          "El mensaje no puede exceder 1000 caracteres",
        max_attempts_invalid:
          "El máximo de intentos debe ser un número entre 1 y 10",
        not_authorized:
          "Solo Dirección puede modificar el catálogo de actividades",
        generic: "No se pudo guardar el cambio. Inténtalo de nuevo.",
      },
    },
    deal_activity_results: {
      title: "Resultados posibles",
      title_new: "Nuevo resultado",
      title_edit: "Editar resultado",
      fields: {
        label: "Etiqueta",
        message_template: "Mensaje",
        message_template_help:
          "Puedes usar {nombre}, {asesora} y {proyecto}; se completan automáticamente al usar el mensaje.",
        message_preview: "Vista previa",
        next_activity_type_id: "Siguiente actividad",
        no_next_activity: "Sin siguiente paso",
        next_step_offset_hours: "Horas hasta el siguiente paso",
        next_step_offset_help:
          "Obligatorio cuando eliges una siguiente actividad.",
      },
      rule_summary: "Siguiente paso: %{activity} en %{hours} h",
      rule_summary_none: "Sin siguiente paso",
      archived_marker: "Archivado",
      next_activity_archived_marker: "Siguiente paso archivado",
      empty: "Esta actividad todavía no tiene resultados.",
      action: {
        new_result: "Nuevo resultado",
        archive: "Archivar",
        reactivate: "Reactivar",
      },
      notifications: {
        created: "Resultado creado",
        updated: "Resultado actualizado",
      },
      archive: {
        archived: "Resultado archivado",
        reactivated: "Resultado reactivado",
        confirm_archive_title: "¿Archivar este resultado?",
        confirm_archive_body:
          "El historial de actividades ya registradas se conserva. El resultado dejará de estar disponible al registrar una actividad; podrás reactivarlo después.",
        confirm_reactivate_title: "¿Reactivar este resultado?",
        confirm_reactivate_body:
          "El resultado volverá a estar disponible al registrar una actividad.",
      },
      error: {
        label_required: "La etiqueta del resultado es obligatoria",
        label_too_long:
          "La etiqueta del resultado no puede exceder 80 caracteres",
        label_duplicate:
          "Ya existe un resultado activo con esa etiqueta para esta actividad",
        message_template_too_long:
          "El mensaje no puede exceder 1000 caracteres",
        offset_required:
          "Las horas del siguiente paso son obligatorias cuando eliges una siguiente actividad",
        offset_invalid:
          "Las horas del siguiente paso deben ser un número entre 0 y 2160",
        not_authorized:
          "Solo Dirección puede modificar el catálogo de actividades",
        generic: "No se pudo guardar el cambio. Inténtalo de nuevo.",
      },
    },
    alert_rules: {
      name: "Regla de alerta |||| Reglas de alerta",
      title: "Alertas",
      fields: {
        label: "Etiqueta",
        enabled: "Activada",
        hours_threshold: "Horas",
        stuck_lead_count_threshold: "Número de leads",
        target_stage_key: "Etapa objetivo",
        appointment_activity_type_id: "Actividad de cita",
      },
      status: {
        enabled: "Activada",
        disabled: "Desactivada",
      },
      threshold: {
        hours: "%{smart_count} hora |||| %{smart_count} horas",
        stuck_count: "%{smart_count} lead |||| %{smart_count} leads",
        stage_activity: "%{stage} · %{activity}",
      },
      description: {
        sin_seguimiento:
          "Te avisamos cuando un lead lleva más de %{hours} h sin seguimiento.",
        detenido_en_etapa:
          "Te avisamos cuando %{count} leads o más llevan detenidos en la misma etapa más tiempo del esperado.",
        cumple_criterio_sin_cita:
          "Te avisamos cuando un lead cumple los criterios para %{stage} pero todavía no tiene programada su %{activity}.",
        alta_intencion_sin_actividad:
          "Te avisamos cuando un lead con alta intención lleva más de %{hours} h sin actividad registrada.",
      },
      detenido_en_etapa: {
        title: "Etapas con tiempo objetivo",
        help: "Esta regla solo aplica a las etapas que tienen un tiempo objetivo configurado.",
        empty: "Todavía no hay etapas con tiempo objetivo configurado.",
        link: "Ir a Etapas",
      },
      empty: "Todavía no hay reglas de alerta configuradas.",
      error: {
        hours_threshold_required: "Ingresa las horas",
        hours_threshold_invalid: "Las horas deben ser un número entre 1 y 2160",
        stuck_lead_count_required: "Ingresa el número de leads",
        stuck_lead_count_invalid:
          "El número de leads debe ser un número entre 1 y 100",
        target_stage_required: "Elige la etapa objetivo",
        appointment_activity_required: "Elige la actividad de cita",
        not_authorized:
          "Solo Dirección puede modificar la configuración de las reglas de alerta",
        generic: "No se pudo guardar el cambio. Inténtalo de nuevo.",
      },
    },
    profile_buyer_types: { title: "Tipo de comprador" },
    profile_credit_types: { title: "Crédito" },
    profile_timelines: { title: "Plazo" },
    profile_motivators: { title: "Motivadores" },
    profile_objections: { title: "Objeciones" },
    lead_sources: {
      name: "Origen del lead |||| Orígenes del lead",
      fields: {
        name: "Nombre",
        color: "Color",
        active: "Activo",
        meta_mapping: "Mapeo de Meta",
      },
    },
    meta_form_projects: {
      name: "Formulario de Meta |||| Formularios de Meta",
      fields: {
        meta_form_id: "Id del formulario de Meta",
        project_id: "Proyecto",
      },
    },
    property_options: {
      name: "Propiedad |||| Inventario Almikia",
      fields: {
        address: "Dirección",
        zone: "Zona",
        property_type: "Tipo",
        price: "Precio",
        status: "Estado",
        responsable: "Responsable",
        origin: "Origen",
        operation: "Operación",
        furnished: "Amueblado",
        exclusivity_signed_on: "Firma del contrato",
        exclusivity_ends_on: "Fin de la vigencia",
        levels: "Niveles",
        bedrooms: "Recámaras",
        bathrooms: "Baños",
        area_m2: "Superficie (m²)",
        parking: "Estacionamientos",
        specs: "Características",
      },
      empty: {
        title: "Todavía no hay propiedades en el Inventario Almikia",
        description:
          "El Inventario Almikia reúne las opciones, las exclusivas y las unidades de los proyectos BPO que puedes ofrecer a tus clientes.",
      },
    },
    inventory_items: {
      name: "Inventario Almikia |||| Inventario Almikia",
    },
    property_option_owners: {
      name: "Propietario |||| Propietarios",
      fields: {
        full_name: "Nombre del propietario",
        phone: "Teléfono",
        email: "Correo electrónico",
        notes: "Notas",
      },
    },
    colegas: {
      name: "Colega |||| Colegas",
      fields: {
        full_name: "Nombre completo",
        phone: "Teléfono (10 dígitos)",
        brokerage: "Inmobiliaria",
        independent: "Independiente",
        email: "Correo electrónico",
        notes: "Notas",
        active: "Activo",
        created_by: "Registrado por",
      },
    },
    operations: {
      name: "Operación |||| Operaciones",
      empty: {
        title: "No se encontraron operaciones",
        description:
          "Las operaciones aparecen cuando apartas una unidad en un lead en cierre.",
      },
    },
    // Almikia Epic E6 (TASK-039): invoicing resources.
    receivables: {
      name: "Cuenta por cobrar |||| Cuentas por cobrar",
      empty: {
        title: "No se encontraron cuentas por cobrar",
        description:
          "Las cuentas por cobrar aparecen cuando se firma una venta o se aprueba el VoBo de una venta de corretaje.",
      },
    },
    payables: {
      name: "Cuenta por pagar |||| Cuentas por pagar",
      empty: {
        title: "No se encontraron cuentas por pagar",
        description:
          "Las cuentas por pagar aparecen cuando el expediente está en verde y la asesora sube su factura.",
      },
    },
    // Almikia Epic EG (TASK-044): gastos.
    expenses: {
      name: "Gasto |||| Gastos",
      empty: {
        title: "No se encontraron gastos",
        description:
          "Aquí se listan los gastos de la agencia, con su categoría, monto y quién pagó.",
      },
    },
    expense_categories: {
      name: "Categoría de gastos |||| Categorías de gastos",
    },
    clients: {
      name: "Cliente |||| Clientes",
      fields: {
        client_type: "Tipo de cliente",
        full_legal_name: "Nombre legal completo",
        rfc: "RFC",
        curp: "CURP",
        birthday: "Fecha de nacimiento",
        marital_status: "Estado civil",
        marital_property_regime: "Régimen matrimonial",
        children_count: "Número de hijos",
        email: "Correo electrónico",
        phone: "Teléfono",
        address: "Dirección",
        contact_id: "Contacto vinculado",
        sales_id: "Responsable",
      },
      client_type: {
        persona_fisica: "Persona física",
        persona_moral: "Persona moral",
      },
      marital_status: {
        soltero: "Soltero(a)",
        casado: "Casado(a)",
        union_libre: "Unión libre",
        divorciado: "Divorciado(a)",
        viudo: "Viudo(a)",
      },
      marital_property_regime: {
        sociedad_conyugal: "Sociedad conyugal",
        separacion_bienes: "Separación de bienes",
      },
      filters: {
        only_mine: "Solo mis clientes",
      },
      empty: {
        description: "Parece que tu lista de clientes está vacía.",
        title: "No se encontraron clientes",
      },
      helper: {
        full_legal_name:
          "Escríbelo exactamente como aparece en la identificación oficial",
      },
      warnings: {
        rfc_duplicate: "Este RFC ya está registrado con otro cliente.",
      },
      action: {
        create: "Crear cliente",
        new: "Nuevo cliente",
      },
      linked_leads: {
        title: "Leads vinculados",
        empty: "No hay leads vinculados a este cliente.",
      },
      upcoming_birthdays: {
        title: "Cumpleaños próximos",
        empty: "No tienes cumpleaños de clientes en los próximos 30 días.",
      },
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Estatus",
        date: "Fecha",
        attachments: "Archivos adjuntos",
        contact_id: "Contacto",
        deal_id: "Lead",
      },
      action: {
        add: "Agregar nota",
        add_first: "Agrega tu primera nota",
        delete: "Eliminar nota",
        edit: "Editar nota",
        update: "Actualizar nota",
        add_this: "Agregar esta nota",
      },
      sheet: {
        create: "Crear nota",
        create_for: "Crear nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota de %{name}",
      },
      deleted: "Nota eliminada",
      empty: "Aún no hay notas",
      author_added: "%{name} agregó una nota",
      you_added: "Agregaste una nota",
      me: "Yo",
      // Almikia Epic EA (TASK-111): marks a `deal_notes` row created by
      // `logDealActivity` (both `activity_type_id`/`activity_result_id` set)
      // in the notes trail, next to a plain note.
      activity_marker: "Actividad",
      list: {
        error_loading: "Error al cargar las notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Ve a la página de un contacto y agrega una nota",
      },
      added: "Nota agregada",
      inputs: {
        add_note: "Agregar una nota",
        options_hint: "(adjunta archivos o cambia detalles)",
        show_options: "Mostrar opciones",
      },
      actions: {
        attach_document: "Adjuntar documento",
      },
      validation: {
        note_or_attachment_required:
          "Se requiere una nota o un archivo adjunto",
      },
    },
    sales: {
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellidos",
        email: "Correo electrónico",
        secondary_email: "Correo secundario",
        secondary_emails: "Correos secundarios",
        administrator: "Administrador",
        role: "Rol",
        disabled: "Desactivado",
        business_arm: "Unidad de negocio",
        business_arm_review: "Revisar unidad de negocio",
        reports_to: "Acompañamiento",
        advisor_code: "Clave de asesora",
        projects: "Proyectos",
        accumulated_sales: "Ventas acumuladas a la fecha",
        accumulated_sales_helper:
          "Se captura una sola vez al ingreso y se suma a las ventas propias del CRM para calcular el nivel.",
        accumulated_sales_invalid:
          "Indica un número entero de ventas (0 o más)",
        level: "Nivel",
        level_empty: "Sin nivel calculado",
        corretaje_projects_blocked:
          "Las personas de Corretaje no tienen proyectos. Termina sus proyectos activos antes de guardar este cambio.",
      },
      create: {
        error: "Ocurrió un error al crear el usuario.",
        success:
          "Usuario creado. Pronto recibirá un correo para definir su contraseña.",
        title: "Crear nuevo usuario",
      },
      edit: {
        error: "Ocurrió un error. Inténtalo de nuevo.",
        record_not_found: "Registro no encontrado",
        success: "Usuario actualizado correctamente",
        title: "Editar a %{name}",
      },
      action: {
        new: "Nuevo usuario",
      },
      empty: {
        description: "Parece que tu lista de usuarios está vacía.",
        title: "No se encontraron usuarios",
      },
      pending_claims: {
        title: "Claves por confirmar",
        roster_clave: "Clave (roster)",
        projects: "Proyectos",
        lider_bpo_marker: "%{name} (Líder BPO)",
        confirm: "Confirmar",
        reject: "Rechazar",
        confirm_title: "Confirmar clave",
        confirm_description: "Esto aplicará los siguientes cambios a %{name}:",
        reject_title: "Rechazar clave",
        reject_description:
          "%{name} podrá volver a reclamar esta fila más tarde. No se modifica su perfil.",
        confirm_success: "Clave confirmada",
        reject_success: "Clave rechazada",
        direccion_only: "Solo Dirección puede confirmarla",
        empty_title: "No hay claves por confirmar",
        empty_description:
          "Cuando alguien reclame una clave del roster, aparecerá aquí.",
      },
      projects: {
        title: "Proyectos",
        lider_bpo: "Líder BPO",
        lider_bpo_marker: "%{name} (Líder BPO)",
        empty: "Sin proyectos activos",
        add_project: "Agregar proyecto",
        add: "Agregar",
        added: "Proyecto agregado",
        add_error: "Ocurrió un error al agregar el proyecto.",
        mark_lider: "Marcar Líder BPO",
        clear_lider: "Quitar Líder BPO",
        end: "Terminar",
        end_title: "Terminar membresía",
        end_description:
          "%{name} dejará de aparecer como proyecto activo de esta persona.",
        ended: "Membresía terminada",
        update_error: "Ocurrió un error. Inténtalo de nuevo.",
      },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      forcedCaseName: "Tarea",
      fields: {
        text: "Descripción",
        due_date: "Fecha de vencimiento",
        type: "Tipo",
        contact_id: "Contacto",
        due_short: "vence",
      },
      action: {
        add: "Agregar tarea",
        create: "Crear tarea",
        edit: "Editar tarea",
      },
      actions: {
        postpone_next_week: "Posponer a la próxima semana",
        postpone_tomorrow: "Posponer a mañana",
        title: "acciones de la tarea",
      },
      added: "Tarea agregada",
      deleted: "Tarea eliminada correctamente",
      dialog: {
        create: "Crear tarea",
        create_for: "Crear tarea para %{name}",
      },
      sheet: {
        edit: "Editar tarea",
        edit_for: "Editar tarea de %{name}",
      },
      empty: "Aún no hay tareas",
      empty_list_hint:
        "Las tareas que agregues a tus contactos aparecerán aquí.",
      filters: {
        later: "Más adelante",
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Mañana",
        with_pending: "Con tareas pendientes",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Tarea actualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: {
        add: "Agregar etiqueta",
        create: "Crear nueva etiqueta",
      },
      dialog: {
        color: "Color",
        create_title: "Crear nueva etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nombre de la etiqueta",
        name_placeholder: "Escribe el nombre de la etiqueta",
      },
    },
    // Almikia Epic EL2 (TASK-074): pantalla "Guardias y asignación" del proyecto.
    guardias: {
      nav: "Guardias y asignación",
      title: "Guardias y asignación",
      intro:
        "Consulta quién está de guardia y a quién le tocan los leads nuevos del proyecto.",
      project_label: "Proyecto",
      no_projects: "Aún no tienes proyectos con esta sección.",
      no_access: "No tienes acceso a esta sección.",
      readonly_note:
        "Aquí solo puedes ver la información. Puedes editar tu propia disponibilidad y tus propios periodos de no disponible.",
      availability_link: "Marcar mi disponibilidad",
      availability_help:
        "Tus guardias se arman con la disponibilidad que marcas. Nada se impone.",
      advisors_title: "Asesoras del proyecto",
      advisors_help:
        "Solo las asesoras activas participan en la asignación automática de leads nuevos.",
      advisors_empty: "Este proyecto no tiene asesoras activas.",
      active_label: "Activa",
      active_aria: "Marcar a %{name} como activa en el proyecto",
      now_title: "En la sala de ventas ahora",
      now_empty: "Nadie está de guardia en este momento.",
      now_you: "Estás de guardia ahora",
      roster_title: "Guardias de la semana",
      roster_help:
        "Cada guardia se arma con la disponibilidad que marcó la asesora.",
      week_prev: "Semana anterior",
      week_next: "Semana siguiente",
      week_range: "Semana del %{from} al %{to}",
      day_empty: "Sin guardias",
      guardia_range: "%{start} a %{end}",
      mine_title: "Mis guardias de esta semana",
      mine_empty: "No tienes guardias esta semana.",
      form_title: "Agregar una guardia",
      form_advisor: "Asesora",
      form_day: "Día",
      form_window: "Disponibilidad marcada",
      form_start: "Desde",
      form_end: "Hasta",
      form_add: "Agregar guardia",
      form_no_availability:
        "Esta asesora no marcó disponibilidad ese día. Pídele que la marque primero.",
      form_outside:
        "La guardia debe quedar dentro de la disponibilidad marcada.",
      form_failed: "No se pudo guardar la guardia.",
      guardia_end: "Quitar",
      guardia_end_aria:
        "Quitar la guardia de %{name} del %{day} a las %{start}",
      hours_title: "Horas de atención de la sala de ventas",
      hours_help:
        "Solo informativas. Deja las dos horas vacías en un día cerrado. Hora de la Ciudad de México.",
      hours_open: "Abre",
      hours_close: "Cierra",
      hours_save: "Guardar horas de atención",
      hours_error_required:
        "Escribe las dos horas del %{day}, o deja ambas vacías.",
      hours_error_order:
        "El %{day}, la hora de cierre debe ser después de la de apertura.",
      unavailable_title: "No disponible",
      unavailable_help:
        "Mientras una asesora está no disponible no recibe leads nuevos. Sus leads se quedan con ella.",
      unavailable_empty: "No hay periodos de no disponible.",
      unavailable_advisor: "Asesora",
      unavailable_start_date: "Desde el día",
      unavailable_start_time: "Hora de inicio",
      unavailable_end_date: "Hasta el día",
      unavailable_end_time: "Hora de fin",
      unavailable_add: "Marcar no disponible",
      unavailable_cancel: "Cancelar",
      unavailable_cancel_aria:
        "Cancelar el periodo de no disponible de %{name}",
      unavailable_range: "%{start} a %{end}",
      unavailable_error_required: "Elige los dos días y las dos horas.",
      unavailable_error_order: "El final debe ser después del inicio.",
      notices_title: "Avisos",
      notices_help:
        "Avisos de seguimiento de la asignación de leads, del más reciente al más antiguo. Abre el lead para ver si se registró un contacto.",
      notices_empty: "No hay avisos.",
      notice_lead_fallback: "Lead %{id}",
      notice_kind: {
        aviso_10_min: "Aviso a los 10 minutos sin contacto",
        reasignacion_24h: "Reasignada a las 24 horas sin contacto",
        sin_asesora_disponible:
          "Sin asesora disponible, se avisó a la Team Leader",
        reasignacion_tope:
          "El lead llegó al tope de reasignaciones y pasó a la Team Leader",
        alerta_cadencia_2d: "Dos días sin contacto con el lead",
        sugerencia_cerrado_perdido:
          "Sugerencia: pasar el lead a Cerrado perdido por falta de respuesta",
      },
      // Almikia Epic EL3: wording of a notice about a proactivo / colega lead (never promises a
      // reassignment).
      notice_kind_protected: {
        aviso_10_min:
          "10 minutos sin contacto. Este lead no se reasigna automáticamente",
      },
      notice_gap_since: "Sin contacto desde %{date}",
      accept_suggestion: "Aceptar sugerencia",
      loss_reason_prefix: "Motivo de cierre",
      suggestion_accepted: "El lead pasó a Cerrado perdido.",
      suggestion_error: "No se pudo pasar el lead a Cerrado perdido.",
      suggestion_note_error:
        "El lead ya está en Cerrado perdido, pero no se pudo guardar la nota del motivo. Agrégala manualmente.",
      limits_title: "Límites de asignación de leads",
      cap_label: "Máximo de leads sin atender por asesora",
      cap_help:
        "Un lead está sin atender cuando está asignado, en Prospecto o Contacto inicial y sin contacto registrado. Vacío significa sin límite.",
      overdue_label: "Umbral de vencido (horas)",
      overdue_help:
        "Un lead está vencido cuando está en Contacto inicial o Discovery y su última actividad es más antigua que este umbral. Vacío significa sin límite.",
      no_limit: "Sin límite",
      limits_save: "Guardar límites",
      limit_error:
        "Escribe un número entero mayor que cero, o deja el campo vacío.",
      saved: "Cambios guardados",
      save_error: "No se pudo guardar. Intenta de nuevo.",
      auto_assigned: "Lead asignado a %{name}. Motivo: %{reason}.",
      reason_label: "Motivo: %{reason}",
      weekday: {
        1: "Lunes",
        2: "Martes",
        3: "Miércoles",
        4: "Jueves",
        5: "Viernes",
        6: "Sábado",
        7: "Domingo",
      },
      reason: {
        lead_nuevo: "Lead nuevo",
        proteccion_90_dias: "Protección 90 días",
        fallback_omision: "Reasignación por omisión",
        aviso_10_min: "Aviso 10 minutos",
        reasignacion_24h: "Reasignación 24 h",
        manual: "Manual",
        reasignacion_direccion: "Reasignación de Dirección",
        reasignacion_lider: "Reasignación del Team Leader",
        baja_de_asesora: "Baja de la asesora",
        tope_reasignaciones: "Tope de reasignaciones: pasa al Team Leader",
      },
    },
  },
  crm: {
    team_status_filter: {
      label: "Estado de las personas del equipo",
      active: "Activos",
      departed: "Bajas",
    },
    // Almikia Epic EC2b (TASK-126): the contact file's "Expediente" tab.
    contact_expediente: {
      tab_general: "Datos generales",
      tab_file: "Expediente",
      loading: "Cargando el expediente",
      retry: "Reintentar",
      denied: "No tienes acceso al expediente de este contacto.",
      load_error:
        "No pudimos cargar el expediente. Intenta de nuevo en un momento.",
      saved: "Guardado",
      save: "Guardar",
      saving: "Guardando",
      save_hint:
        "Puedes guardar en cualquier momento, aunque falten datos. Nada es obligatorio para guardar.",
      progress: "%{done} de %{total}",
      progress_label: "Avance del expediente",
      missing_title: "Qué falta",
      complete_title: "El expediente está completo",
      who_uploads:
        "Lo captura la persona responsable del contacto, su líder, Dirección, administración o compliance.",
      kind_title: "Tipo de persona",
      section_fisica: "Datos de la persona física",
      section_moral: "Datos de la persona moral",
      section_address: "Domicilio",
      section_id: "Identificación oficial",
      section_pld: "Prevención de lavado de dinero",
      section_docs: "Documentos",
      yes: "Sí",
      no: "No",
      choose: "Selecciona",
      owner_self: "Es la misma persona",
      owner_other: "Es otra persona",
      id_expired: "La identificación está vencida. Captura una vigente.",
      regime_required: "Indica el régimen patrimonial del matrimonio",
      owner_name_required: "Indica el nombre del beneficiario controlador",
      kind_required: "Selecciona el tipo de persona (física o moral)",
      doc_uploaded: "Subido",
      doc_missing: "Falta",
      doc_optional: "Opcional",
      doc_by: "Lo sube la persona responsable o su líder",
      doc_pep_required: "Obligatorio porque es una persona expuesta",
      doc_upload: "Subir archivo",
      doc_replace: "Reemplazar",
      doc_view: "Ver",
      doc_remove: "Quitar",
      doc_remove_title: "Quitar documento",
      doc_remove_hint:
        "El archivo se conserva en el expediente; solo deja de contar como vigente.",
      doc_working: "Procesando",
      restricted_title: "Qué falta en este expediente",
      restricted_note:
        "Solo la persona responsable del contacto, su líder, Dirección, administración y compliance capturan y ven los datos del expediente.",
      restricted_empty: "No falta nada en este expediente.",
      restricted_error:
        "No pudimos consultar qué falta. Intenta de nuevo en un momento.",
    },
    // Almikia Epic EN (TASK-091): internal WhatsApp notices UI.
    internalNotices: {
      roles: {
        direccion: "Dirección",
        lead_manager: "Lead Manager",
        lider: "Líder",
        asesora: "Asesora",
        administracion: "Administración",
      },
      settings: {
        nav: "Avisos internos",
        manage_link: "Configurar avisos internos",
        title: "Avisos internos",
        intro:
          "Elige quién recibe los avisos internos por WhatsApp, revisa el uso del número de avisos y envía un aviso de prueba.",
        state_off: "Desactivado (valor por defecto)",
        state_on:
          "Activado para %{smart_count} persona |||| Activado para %{smart_count} personas",
      },
      users: {
        title: "Personas",
        help: "Los avisos están apagados para todas las personas hasta que los actives uno por uno.",
        load_error: "No se pudo cargar la lista de personas",
        empty: "No hay personas activas para mostrar",
        switch_label: "Avisos internos de %{name}",
        general_summary_label: "%{name} recibe el resumen general",
        phone_yes: "Con teléfono registrado",
        phone_no: "Sin teléfono",
        no_phone_reason:
          "No se puede activar: esta persona no tiene un teléfono +52 registrado.",
        toggle_error: "No se pudo cambiar el aviso interno. Intenta de nuevo",
        summary_error:
          "No se pudo cambiar el resumen general. Intenta de nuevo",
        show_more: "Mostrar más personas",
      },
      usage: {
        title: "Número de avisos",
        month_label: "Mes",
        used: "%{used} de %{quota} mensajes de atención gratuitos usados",
        progress_label: "Mensajes de atención usados este mes",
        warning_80: "Ya usaste el 80 % de los mensajes gratuitos de este mes",
        warning_100:
          "Llegaste al límite gratuito: los siguientes mensajes de atención tendrán costo",
        paid_templates: "Plantillas con costo: %{count}",
        error: "No se pudo cargar el uso del número de avisos",
        note: "Solo se cuentan los mensajes del número de avisos. Aquí nunca se muestra ningún teléfono.",
      },
      test: {
        button: "Enviar aviso de prueba",
        button_for: "Enviar aviso de prueba a %{name}",
        sending: "Enviando...",
        success: "Aviso de prueba enviado",
        error: "No se pudo enviar el aviso de prueba. Intenta más tarde",
      },
      config: {
        title: "Configuración",
        window: "Ventana de agrupación (minutos)",
        window_help:
          "Los leads nuevos que llegan dentro de esta ventana se agrupan en un solo aviso.",
        weekends: "Enviar resúmenes también en fines de semana",
        holidays: "Días festivos (sin resumen)",
        holidays_help: "Una fecha por línea, con formato AAAA-MM-DD.",
        invalid:
          "Revisa los valores: la ventana debe ser un número entero mayor que 0 y las fechas deben tener el formato AAAA-MM-DD.",
        saved: "Configuración guardada",
        save_error: "No se pudo guardar la configuración. Intenta de nuevo",
        load_error: "No se pudo cargar la configuración",
      },
      profile: {
        summaries_label: "Recibir resúmenes de las 8:30 y 20:30",
        summaries_help:
          "Los avisos de lead nuevo y los urgentes no cambian con esta opción.",
        saved: "Preferencia guardada",
        error: "No se pudo guardar tu preferencia. Intenta de nuevo",
      },
      take: {
        line: "Lo tomó %{name} el %{date}",
      },
    },
    action: {
      reset_password: "Restablecer contraseña",
    },
    // Almikia Epic E3b (TASK-067): sign-in prompt asking a clave-less
    // asesora for her clave de asesora ("Ahora no" postpones it).
    advisorCodePrompt: {
      title: "Agrega tu clave de asesora",
      description:
        "Necesitas tu clave de asesora para recibir leads. Agrégala cuando la tengas; también puedes hacerlo después desde tu perfil.",
      postpone: "Ahora no",
      saved: "Tu clave de asesora se guardó",
      required: "Escribe tu clave para guardarla",
    },
    auth: {
      first_name: "Nombre",
      last_name: "Apellidos",
      confirm_password: "Confirmar contraseña",
      confirmation_required:
        "Sigue el enlace que te acabamos de enviar por correo para confirmar tu cuenta.",
      recovery_email_sent:
        "Si eres un usuario registrado, en breve recibirás un correo para recuperar tu contraseña.",
      sign_in_failed: "No se pudo iniciar sesión.",
      sign_in_google_workspace: "Iniciar sesión con Google Workspace",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Crea la primera cuenta de usuario para completar la configuración.",
        creating: "Creando...",
        initial_user_created: "Usuario inicial creado correctamente",
      },
      official_email_required:
        "Solo se pueden crear cuentas con correo @almikia.com.",
      welcome_title: "Te damos la bienvenida a Almikia CRM",
    },
    common: {
      account_manager: "Responsable de la cuenta",
      activity: "Actividad",
      added: "agregó",
      details: "Detalles",
      last_activity_with_date: "última actividad %{date}",
      load_more: "Cargar más",
      misc: "Otros",
      past: "Pasadas",
      read_more: "Leer más",
      retry: "Reintentar",
      show_less: "Mostrar menos",
      copied: "¡Copiado!",
      copy: "Copiar",
      loading: "Cargando…",
      list_error: "No se pudo cargar la lista.",
      test_data_badge: "Datos de prueba",
      test_data_filter_label: "Datos de prueba",
      test_data_filter_all: "Incluir datos de prueba",
      test_data_filter_only: "Solo datos de prueba",
      test_data_filter_hide: "Ocultar datos de prueba",
      clear_filters: "Quitar filtros",
      me: "Yo",
      task_count: "%{smart_count} tarea |||| %{smart_count} tareas",
      value_of: "%{count} de %{total}",
    },
    changelog: {
      title: "Novedades",
    },
    // Almikia Epic EO (TASK-098): the "Almikia" section landing, one tap
    // away from the desktop rail / mobile bottom navigation for every role.
    almikia: {
      nav_label: "Almikia",
      title: "Almikia",
      organigrama_entry: "Organigrama",
      cultura_entry: "Nuestra cultura",
    },
    // Almikia Epic EO (TASK-098): the "Organigrama" screen. Position labels,
    // brazo/group section headers, the "Líder BPO" marker and the
    // Coordinación/Acompañamiento relationship words are fixed Spanish
    // business vocabulary (see `orgChartLayout.ts` and `sales/roles.ts`),
    // shown as-is whatever the app locale -- never routed through these
    // per-locale keys.
    // Almikia Epic EC2c (TASK-133): quick-contact buttons of a team profile.
    team_contact: {
      whatsapp: "WhatsApp",
      call: "Llamar",
      email: "Correo",
    },
    org_chart: {
      title: "Organigrama",
      empty_title: "Aún no hay personas en el organigrama",
      empty_description: "En cuanto haya personas activas, aparecen aquí.",
      card: {
        arm_label: "Unidad de negocio",
        level_label: "Nivel",
        projects_label: "Proyectos",
        relationship_label: "Relación",
        advisor_code_label: "Clave",
        phone_label: "Teléfono",
        email_label: "Correo",
      },
    },
    // Almikia Epic EO (TASK-099): the "Nuestra cultura" screen -- Visión,
    // Misión, Valores and Manifiesto, read from `culture_documents_current`
    // and shown verbatim (their titles/bodies are fixed business content,
    // never routed through per-locale keys; only the page chrome is here).
    culture: {
      title: "Nuestra cultura",
      empty_title: "Aún no hay contenido de cultura",
      empty_description: "En cuanto se publiquen documentos, los verás aquí.",
      action: {
        edit: "Editar",
        history: "Historial",
        new_document: "Nuevo documento",
      },
      // Almikia Epic EO (TASK-100): "Historial" -- every version of a
      // culture document, newest first.
      history: {
        title: "Historial de %{title}",
        empty: "Aún no hay versiones.",
        back_to_list: "Volver al historial",
        version_number: "Versión %{number}",
        // DATA CONTRACT EO (3): the seeded rows have `created_by: null`.
        seeded: "Carga inicial",
      },
      // Almikia Epic EO (TASK-100): the direccion-only editor -- "Editar"
      // on an existing document or "Nuevo documento".
      editor: {
        new_title: "Nuevo documento",
        edit_title: "Editar %{title}",
        title_label: "Título",
        body_label: "Contenido (Markdown)",
        toolbar_label: "Formato de texto",
        tab: {
          edit: "Editar",
          preview: "Vista previa",
        },
        preview_empty: "Escribe contenido para ver la vista previa.",
        format: {
          bold: "Negritas",
          italic: "Cursivas",
          bullet: "Lista con viñetas",
          link: "Enlace",
        },
        action: {
          save: "Guardar nueva versión",
        },
        success: "Se guardó una nueva versión.",
        error: {
          title_required: "El título no puede estar vacío.",
          title_too_long: "El título no puede tener más de 120 caracteres.",
          body_required: "El contenido no puede estar vacío.",
          body_too_long:
            "El contenido no puede tener más de 20,000 caracteres.",
          no_changes: "No hay cambios que guardar.",
          save_failed: "No se pudo guardar la nueva versión.",
        },
      },
    },
    activity: {
      added_company: "%{name} agregó la empresa",
      you_added_company: "Agregaste la empresa",
      added_contact: "%{name} agregó a",
      you_added_contact: "Agregaste a",
      added_note: "%{name} agregó una nota sobre",
      you_added_note: "Agregaste una nota sobre",
      added_note_about_deal: "%{name} agregó una nota sobre el lead",
      you_added_note_about_deal: "Agregaste una nota sobre el lead",
      added_deal: "%{name} agregó el lead",
      you_added_deal: "Agregaste el lead",
      at_company: "en",
      to: "a",
      load_more: "Cargar más actividad",
    },
    dashboard: {
      deals_chart: "Ingresos próximos de leads",
      deals_pipeline: "Embudo de leads",
      latest_activity: "Actividad reciente",
      latest_activity_error: "Error al cargar la actividad reciente",
      latest_notes: "Mis notas recientes",
      latest_notes_added_ago: "agregada %{timeAgo}",
      stepper: {
        install: "Instalar Almikia CRM",
        progress: "%{step}/3 completados",
        whats_next: "¿Qué sigue?",
      },
      upcoming_tasks: "Próximas tareas",
      hoy: {
        greeting: "Hola, %{name}",
        ring_label: "Tu plan de hoy",
        ring_title: "Tu plan de hoy",
        ring_unit: "de %{total}",
        plan_all_done: "Vas al día. No tienes toques pendientes.",
        plan_pending:
          "Falta %{smart_count} toque; el más urgente es %{name}. |||| Faltan %{smart_count} toques; el más urgente es %{name}.",
        plan_pending_with_hours:
          "Falta %{smart_count} toque; el más urgente es %{name}, llegó hace %{hours} h. |||| Faltan %{smart_count} toques; el más urgente es %{name}, llegó hace %{hours} h.",
        list_title: "Quién te necesita hoy",
        empty_title: "Hoy no tienes pendientes",
        empty_description: "No hay toques, cumpleaños ni POSI por completar.",
        action: {
          whatsapp: "Enviar WhatsApp",
          call: "Llamar",
          // Almikia Epic EF (TASK-122): opens `DealProfileSheet` from the
          // Hoy card, the only mobile entry point to the 'Perfil del
          // cliente' section (mobile has no lead screen, QEA11).
          view_profile: "Perfil del cliente",
        },
        reason: {
          prospect: "Lead sin respuesta aún",
          task_overdue: "Tarea vencida",
          task_today: "Tarea de hoy",
          // Almikia Epic EA (TASK-112): a catalogue next-step task names its
          // activity instead of the generic "Tarea vencida"/"Tarea de hoy".
          next_step_overdue: "%{activity} · vencida",
          next_step_today: "%{activity} · hoy",
          birthday_today: "Cumpleaños hoy",
          birthday_tomorrow: "Cumpleaños mañana",
          posi_incomplete: "POSI %{answered} de 4 · falta %{field}",
        },
        posi_field: {
          posi_intent: "intención",
          posi_budget: "presupuesto",
          posi_payment_method: "forma de pago",
          posi_decision_maker: "quién decide",
        },
        my_progress_link: "Ver mi avance",
      },
      lider: {
        greeting: "Hola, %{name}",
        my_day_link: "Ver mi día",
        my_progress_link: "Ver mi avance",
        team_goal_title: "Equipo vs meta del mes",
        no_goal: "Sin meta definida",
        units_and_amount: "%{units} ventas directas · %{amount}",
        units_missing:
          "Le falta %{smart_count} venta para su meta |||| Le faltan %{smart_count} ventas para su meta",
        goal_reached: "Meta cumplida",
        units_bar_label: "Avance de unidades contra la meta",
        amount_progress: "%{actual} de %{target}",
        set_goal_action: "Definir meta",
        team_title: "Tu equipo",
        team_empty_title: "Todavía no tienes asesoras en tu equipo",
        team_empty_description:
          "En cuanto se te asignen asesoras, aparecen aquí.",
        best_bpo_team_units_and_amount: "%{units} ventas directas · %{amount}",
        funnel_title: "Embudo del equipo",
        funnel_empty_title: "No hay leads abiertos en tu equipo",
        expiring_title: "Por vencer",
        expiring_empty_title: "No hay leads por vencer",
        expiring_hours: "%{hours} h",
        posi_incomplete_title: "POSI incompleto",
        posi_incomplete_empty_title: "No hay leads con POSI incompleto",
        pending_ops_title: "Operaciones con documentos pendientes",
        pending_ops_empty_title: "Todavía no hay operaciones registradas",
        pending_ops_empty_description:
          "En cuanto se registren operaciones, aparecen aquí.",
      },
      direccion: {
        eyebrow: "Dirección · %{period}",
        greeting: "Hola, %{name}",
        month_bar_days_left:
          "Queda %{smart_count} día |||| Quedan %{smart_count} días",
        month_bar_need_sentence:
          "Para llegar a %{target} venta necesitas %{missing} más |||| Para llegar a %{target} ventas necesitas %{missing} más",
        hero_title: "Ventas directas del mes",
        hero_units: "%{smart_count} venta |||| %{smart_count} ventas",
        hero_units_of_target:
          "%{units} de %{target} venta |||| %{units} de %{target} ventas",
        pipeline_title: "Embudo · totales por etapa",
        pipeline_row:
          "%{smart_count} lead · %{amount} |||| %{smart_count} leads · %{amount}",
        projects_title: "Proyectos · ventas del mes",
        projects_empty: "Todavía no hay proyectos activos.",
        project_sales_row:
          "%{smart_count} venta · %{amount} |||| %{smart_count} ventas · %{amount}",
        posi_title: "Leads activos con POSI completo",
        posi_percent: "%{percent}%",
        posi_bar_label: "Porcentaje de leads activos con POSI completo",
        vobo_title: "Necesitan tu VoBo",
        vobo_empty_title: "Todavía no hay nada esperando tu VoBo",
        vobo_empty_description:
          "En cuanto haya algo que requiera tu autorización, aparece aquí.",
        operations_title: "Operaciones por semáforo",
        operations_empty_title: "Todavía no hay operaciones registradas",
        operations_empty_description:
          "En cuanto se registren operaciones, aparecen aquí.",
        collections_title: "Cobranza",
        collections_empty_title: "Todavía no hay información de cobranza",
        partial_data_note:
          "Datos parciales: hay más de 1,000 registros; esta cifra no incluye todos.",
        collections_empty_description:
          "En cuanto haya información de cobranza, aparece aquí.",
        // Almikia Epic ER (TASK-004, vision #13): the funnel section --
        // per-stage conversion/time, first-response/contactability
        // (direccion only) and the rule-based bottleneck narrative.
        funnel: {
          title: "Embudo · conversión y tiempos",
          project_filter_label: "Proyecto",
          lead_type_filter_label: "Tipo de lead",
          advisor_filter_label: "Asesora",
          filter_all_option: "Todas",
          conversion_label: "Conversión a la siguiente etapa",
          conversion_percent: "%{percent}%",
          time_in_stage_label: "Tiempo mediano en la etapa",
          time_hours: "%{hours} h",
          time_days: "%{days} d",
          leads_count: "%{smart_count} lead |||| %{smart_count} leads",
          no_data: "Sin datos suficientes",
          first_response_title: "Tiempo de primera respuesta",
          contactability_title: "Contactabilidad",
          contactability_percent: "%{percent}%",
          empty_title: "No hay leads en este filtro",
          empty_description: "Ajusta los filtros para ver el embudo.",
        },
        // Almikia Epic ER (vision #12, TASK-008): the Direccion "leads that
        // need attention" section -- alerts grouped by rule, plus the
        // "N stuck in stage" highlight. A dedicated namespace block, distinct
        // from the advisor-facing `crm.dashboard.alerts` block below (the
        // alert SENTENCE itself is still plain-Spanish domain text, built by
        // `alerts/alertMessage.ts`, never translated here).
        alerts: {
          section_title: "Leads que necesitan atención",
          empty_title: "Ningún lead necesita atención por ahora",
          rule_group_leads_count:
            "%{smart_count} lead |||| %{smart_count} leads",
          view_all: "Ver todos (%{count})",
          stuck_stage_summary:
            "%{stage}: %{smart_count} lead |||| %{stage}: %{smart_count} leads",
          stuck_stage_highlight:
            "Tienes %{smart_count} lead detenido en %{stage} |||| Tienes %{smart_count} leads detenidos en %{stage}",
        },
      },
    },
    // Almikia Epic ER (TASK-007): the advisor-facing lead-alert surfaces
    // (Hoy's alert cards, the lead page's alert pills) -- the alert
    // sentence itself is plain-Spanish domain text built by
    // `alerts/alertMessage.ts`, not translated here (same precedent as the
    // WhatsApp message templates below).
    alerts: {
      section_title: "Alertas de tus leads",
      empty: "No tienes alertas pendientes",
      view_all: "Ver todas (%{count})",
    },
    // Almikia Epic EW1 (TASK-124): the shared "Enviar WhatsApp" action --
    // every label the wave-3 placements (Hoy, lead show, contact show) need,
    // so none of them adds its own i18n keys.
    whatsapp: {
      action_label: "Enviar WhatsApp a %{nombre}",
      chooser: {
        title: "¿A qué lead corresponde?",
        error: "No se pudieron cargar tus leads",
        open_without_logging: "Abrir sin registrar",
      },
      // Almikia Epic EW2 (TASK-079): conversation timeline, clock bars and composer.
      conversation: {
        title: "Conversación de WhatsApp",
        empty: "Sin mensajes de WhatsApp todavía",
        error: "No se pudo cargar la conversación de WhatsApp",
        retry: "Reintentar",
        load_older: "Ver mensajes anteriores",
        sender: {
          customer: "Cliente",
          app: "Pepe (app)",
          advisor_fallback: "Asesora",
        },
        status: {
          pending: "Enviando",
          received: "Recibido",
          sent: "Enviado",
          delivered: "Entregado",
          read: "Leído",
          failed: "Falló: %{error}",
        },
        media: "Archivo adjunto (%{mime})",
        template_message: "Plantilla: %{name}",
        clock: {
          free_text_title: "Escribir libre",
          free_text_left: "%{time} restantes",
          free_text_closed: "Solo plantillas",
          free_messages_title: "Mensajes gratis",
          free_messages_left: "%{time} restantes",
          free_messages_closed: "Los mensajes ya tienen costo",
        },
        composer: {
          text_label: "Mensaje de WhatsApp",
          placeholder: "Escribe tu mensaje",
          send: "Enviar",
          closed_notice:
            "La ventana de 24 horas está cerrada: solo puedes enviar una plantilla aprobada.",
          templates_off: "Las plantillas de WhatsApp aún no están habilitadas.",
          template_label: "Plantilla",
          template_placeholder: "Elige una plantilla",
          variable_label: "Valor de %{name}",
          cost_free: "Gratis",
          cost_paid: "Con costo",
          confirm_title: "Esta plantilla puede tener costo",
          confirm_body:
            "Enviar «%{name}» puede generar un cargo en tu cuenta de WhatsApp. ¿Quieres enviarla?",
          confirm_send: "Enviar con costo",
          cancel: "Cancelar",
          sent_notice: "Mensaje enviado",
          send_error: "No se pudo enviar el mensaje",
        },
        send_errors: {
          ventana_cerrada:
            "La ventana de 24 horas está cerrada: solo puedes enviar una plantilla aprobada",
          confirmacion_costo: "Esta plantilla tiene costo: confirma el envío",
          plantillas_deshabilitadas:
            "Las plantillas de WhatsApp aún no están habilitadas",
          limite_envios: "Estás enviando demasiado rápido: espera un momento",
          envio_fallido: "No se pudo enviar el mensaje por WhatsApp",
          sin_configuracion: "WhatsApp no está configurado: no se envió nada",
          desconocido: "No se pudo enviar el mensaje",
        },
      },
      not_recorded_notice:
        "Se abrió WhatsApp, pero no se pudo registrar el contacto en el lead",
      // Almikia Epic EW3 (TASK-095): 'Sin clasificar' tray, personal numbers and the permission.
      // Almikia Epic EW4 (TASK-110): the read-only message thread of a tray / inbox row.
      thread: {
        show: "Ver mensajes",
        hide: "Ocultar mensajes",
      },
      unclassified: {
        nav: "Sin clasificar",
        settings_heading: "WhatsApp: clasificar contactos",
        title: "Sin clasificar",
        intro:
          "Conversaciones de WhatsApp que todavía no son un lead. Elige si es un lead o un contacto personal.",
        numbers_link: "Números personales",
        empty: "No hay conversaciones sin clasificar",
        error: "No se pudieron cargar las conversaciones sin clasificar",
        show_more: "Mostrar más",
        echo: "Pepe (app)",
        last_activity: "Última actividad: %{at}",
        es_lead: "Es lead",
        cancel: "Cancelar",
        known_contact: "Contacto conocido:",
        known_contact_open: "Ver contacto",
        lead: {
          from_contact: "El lead se crea a partir del contacto %{name}.",
          unit: "Unidad de negocio",
          unit_bpo: "BPO",
          unit_corretaje: "Corretaje",
          mode_advisor_corretaje: "Una asesora de corretaje",
          mode_holder: "Me la quedo yo",
          title: "Clasificar como lead",
          help: "Elige el proyecto, el tipo y el origen del lead, y a quién se asigna.",
          choose: "Elige una opción",
          project: "Proyecto",
          type: "Tipo de lead",
          source: "Origen",
          assign: "Asignación",
          mode_advisor: "Asignar directamente a una asesora",
          mode_carousel: "Enviar al carrusel",
          advisor: "Asesora",
          carousel_help:
            "El lead entra al carrusel y se asigna con la regla de entrada.",
          submit: "Crear lead",
          success: "Lead creado.",
          open: "Abrir lead",
          error: "No se pudo crear el lead. Intenta de nuevo.",
        },
        errors: {
          project_required: "Elige el proyecto",
          type_required: "Elige el tipo de lead",
          source_required: "Elige el origen",
          advisor_required: "Elige a la asesora",
          carousel_not_applicable:
            "El carrusel solo aplica a leads BPO o Almikia",
        },
        personal: {
          action: "Personal",
          title: "Marcar como personal",
          sentence:
            "Este número no es de negocio: se eliminarán sus mensajes guardados y los nuevos se ignorarán.",
          confirm: "Eliminar y marcar como personal",
          success: "Número marcado como personal.",
          error: "No se pudo marcar como personal. Intenta de nuevo.",
        },
      },
      numbers: {
        nav: "Números personales",
        title: "Números personales",
        intro:
          "Los mensajes de estos números se ignoran y no se guardan; solo se cuenta cuántos llegaron.",
        tray_link: "Sin clasificar",
        paste_label: "Pega los números",
        paste_help:
          "Uno por línea, o separados por coma o punto y coma. También puedes subir un archivo CSV.",
        file_label: "O sube un archivo CSV",
        load: "Cargar lista",
        empty_input: "Pega o sube al menos un número",
        too_many: "Máximo %{max} números por carga",
        load_error: "No se pudo cargar la lista. Intenta de nuevo.",
        result:
          "Cargados: %{loaded}. Repetidos: %{duplicates}. Rechazados: %{rejected}.",
        list_title: "Lista actual",
        empty: "Todavía no hay números personales",
        error: "No se pudo cargar la lista de números personales",
        ending: "Número terminado en %{last4}",
        dropped: "Mensajes ignorados: %{count}",
        last_seen: "Último mensaje: %{at}",
        never_seen: "Todavía no ha escrito",
        remove: "Quitar de la lista",
        remove_help:
          "Los mensajes que ya se eliminaron no se recuperan. Los nuevos se guardarán otra vez.",
        remove_confirm: "Quitar",
        removed: "Número quitado de la lista.",
        remove_error: "No se pudo quitar el número. Intenta de nuevo.",
      },
      classify_permission: {
        title: "Clasificar contactos de WhatsApp",
        label: "Puede clasificar contactos de WhatsApp",
        help: "Da acceso a la bandeja Sin clasificar y a los números personales.",
        on: "Permiso concedido.",
        off: "Permiso retirado.",
        error: "No se pudo cambiar el permiso. Intenta de nuevo.",
      },
      // Almikia Epic EW2 (TASK-080): Inbox, counter, settings and lead-row badges.
      badges: {
        alert_24h: "Escribir libre por vencer",
        alert_ctwa: "Mensajes gratis por vencer",
        responde: "Responde",
        unread: "%{count} sin leer",
      },
      inbox: {
        nav: "Bandeja de WhatsApp",
        title: "Bandeja de WhatsApp",
        intro:
          "Las conversaciones de WhatsApp de tu equipo. Abre un lead para responder.",
        unmatched_title: "Sin lead",
        conversations_title: "Conversaciones",
        empty: "Todavía no hay conversaciones de WhatsApp",
        empty_unmatched: "No hay conversaciones sin lead",
        error: "No se pudo cargar la bandeja de WhatsApp",
        pagination: "Paginación de la bandeja",
        previous: "Anterior",
        next: "Siguiente",
        page_of: "Página %{page} de %{pages}",
        no_messages: "Sin mensajes",
        media_message: "Archivo adjunto",
        lead_fallback: "Lead",
        unmatched_name: "Conversación sin lead",
        window: {
          free_text: "Escribir libre",
          ctwa: "Mensajes gratis",
          closed: "Solo plantillas",
        },
        open_lead: "Abrir lead",
        link: "Vincular a un lead",
        create_lead: "Crear lead",
        create_lead_desktop_only:
          "Para crear un lead, abre el CRM en una computadora.",
        create_error: "No se pudo preparar el lead. Intenta de nuevo",
        link_title: "Vincular conversación a un lead",
        link_help: "Elige el lead al que pertenece esta conversación.",
        link_label: "Lead",
        link_placeholder: "Elige un lead",
        link_leads_error: "No se pudieron cargar los leads",
        link_error: "No se pudo vincular la conversación",
        link_success: "Conversación vinculada al lead",
        link_confirm: "Vincular",
        cancel: "Cancelar",
        link_after_create_error:
          "El lead se creó, pero no se pudo vincular la conversación. Vincúlala desde la bandeja",
      },
      health: {
        title: "Conexión de WhatsApp",
        help: "Comprueba que los dos números de WhatsApp responden. No envía ningún mensaje.",
        button: "Probar conexión de WhatsApp",
        checking: "Probando…",
        retry: "Reintentar",
        inbox: "Bandeja de clientes",
        alerts: "Avisos internos",
        connected: "Conectado",
        not_configured: "Falta configurar WhatsApp",
        meta_error: "Error %{code}: %{message}",
        error: "No se pudo comprobar la conexión. Inténtalo de nuevo.",
      },
      counter: {
        title: "Mensajes de atención del mes",
        month_label: "Mes",
        number: "Número del inbox",
        number_n: "Número del inbox %{index}",
        used: "%{used} de %{quota} mensajes gratis usados",
        progress_label: "Mensajes de atención usados del mes",
        warning: "Ya usaste el 80% de los mensajes gratis del mes",
        full: "Llegaste al límite gratis: los siguientes mensajes de atención tendrán costo",
        paid_templates: "Plantillas con costo: %{count}",
        error: "No se pudo cargar el contador",
        empty: "Todavía no hay actividad de WhatsApp este mes",
        note: "Los mensajes enviados desde la app de WhatsApp Business y las plantillas no cuentan como mensajes de atención.",
      },
      settings: {
        nav: "WhatsApp",
        manage_link: "Configurar WhatsApp",
        title: "Configuración de WhatsApp",
        intro:
          "Ventanas, cuota gratis, alertas, plantillas y puesta en marcha del WhatsApp del inbox.",
        config_title: "Configuración",
        config_help:
          "Estos valores se leen del servidor: cámbialos aquí, no en el código.",
        load_error: "No se pudo cargar la configuración de WhatsApp",
        go_live_title: "Puesta en marcha",
        templates_enabled: "Plantillas de WhatsApp",
        templates_enabled_help:
          "Permite enviar plantillas aprobadas desde la ficha del lead.",
        welcome_enabled: "Plantilla de bienvenida",
        welcome_enabled_help:
          "Envía la plantilla de bienvenida a los leads que llegan por formulario.",
        flag_on: "Activado",
        flag_off: "Desactivado (valor por defecto)",
        window_direct: "Ventana de escribir libre (horas)",
        window_direct_help:
          "Horas que dura la ventana desde el último mensaje del cliente.",
        ctwa_free: "Ventana de mensajes gratis (horas)",
        ctwa_free_help:
          "Horas gratis cuando el lead llega desde un anuncio (7 días = 168).",
        quota: "Cuota gratis mensual",
        quota_help: "Mensajes de atención gratis por mes y por número.",
        alert_24h: "Alerta de escribir libre (horas restantes)",
        alert_24h_help: "Se avisa cuando quedan menos de estas horas.",
        alert_ctwa: "Alerta de mensajes gratis (días restantes)",
        alert_ctwa_help: "Se avisa cuando queda menos de estos días.",
        rate_limit: "Límite de envíos por minuto",
        rate_limit_help: "Máximo de mensajes que el CRM envía cada minuto.",
        welcome_title: "Plantilla de bienvenida",
        welcome_name: "Nombre de la plantilla",
        welcome_language: "Idioma",
        welcome_variables: "Variables, en orden",
        welcome_variables_help:
          "Separadas por comas: first_name, project, advisor_name.",
        greeting: "Saludo para leads de botón",
        greeting_help: "Usa {nombre} y {asesora}. Máximo 1,000 caracteres.",
        invalid: "Revisa estos campos: %{fields}",
        field: {
          windowDirectHours: "Ventana de escribir libre",
          ctwaFreeHours: "Ventana de mensajes gratis",
          monthlyFreeQuota: "Cuota gratis mensual",
          alert24hHoursLeft: "Alerta de escribir libre",
          alertCtwaDaysLeft: "Alerta de mensajes gratis",
          sendRateLimit: "Límite de envíos",
          welcomeName: "Nombre de la plantilla de bienvenida",
          welcomeLanguage: "Idioma",
          greeting: "Saludo",
        },
        save: "Guardar",
        saved: "Guardado",
        save_error: "No se pudo guardar",
        templates_title: "Catálogo de plantillas",
        templates_help:
          "Las plantillas se archivan, nunca se borran. Deben estar aprobadas en WhatsApp Manager.",
        templates_empty: "Todavía no hay plantillas",
        template_label: "Nombre para mostrar",
        template_name: "Nombre en WhatsApp (minúsculas y _)",
        template_language: "Idioma (por ejemplo es_MX)",
        template_variables: "Variables, separadas por comas",
        template_paid: "Tiene costo",
        template_invalid:
          "Revisa el nombre (minúsculas, números y _), el idioma y el nombre para mostrar",
        template_add: "Agregar plantilla",
        template_add_confirm: "Agregar",
        paid: "Con costo",
        free: "Gratis",
        archived: "Archivada",
        rename: "Editar",
        mark_free: "Marcar como gratis",
        mark_paid: "Marcar con costo",
        archive: "Archivar",
        restore: "Restaurar",
      },
    },
    // Almikia Epic EI (TASK-004): AI copilot suggestion card and lead actions.
    ai: {
      card_aria: "Sugerencia de IA",
      label: "✦ Sugerencia · revísala antes de enviar",
      because: "Porque:",
      send: "Enviar",
      edit: "Editar",
      dismiss: "Ahora no",
      apply: "Aplicar al perfil",
      understood: "Entendido",
      loading: "Preparando sugerencia…",
      panel_title: "Copiloto IA",
      suggest_message: "Sugerir mensaje",
      whats_missing: "¿Qué me falta?",
      objective_title: "¿Para qué es el mensaje?",
      objectives: {
        showing: "Llevarlo a Showing",
        follow_up: "Retomar el contacto",
        doubts: "Resolver una duda",
        next_step: "Acordar el siguiente paso",
      },
      message_label: "Mensaje",
      no_contact: "Agrega un contacto con teléfono para enviar",
      chips_title: "Datos propuestos para el perfil",
      questions_title: "Preguntas pendientes",
      missing_title: "Lo que falta",
      missing_because:
        "estos datos aún no están en el perfil ni en POSI de este lead.",
      nothing_missing: "No falta nada por ahora",
      edit_hint: "Ajusta el perfil del cliente más abajo",
      apply_error: "No se pudo aplicar al perfil. Intenta de nuevo.",
    },
    // Almikia Epic EL (TASK-009): the advisor's own "Mi disponibilidad" screen.
    availability: {
      nav: "Mi disponibilidad",
      title: "Mi disponibilidad",
      intro: "Elige los bloques en los que quieres recibir leads nuevos.",
      list_title: "Mis bloques",
      time_zone: "Hora de la Ciudad de México (%{zone})",
      empty: "Aún no has elegido bloques.",
      range: "de %{start} a %{end}",
      end: "Terminar bloque",
      end_aria: "Terminar el bloque del %{day} que empieza a las %{start}",
      add_title: "Agregar un bloque",
      weekday_label: "Día de la semana",
      start_label: "Desde",
      end_label: "Hasta",
      add: "Agregar bloque",
      weekday_1: "Lunes",
      weekday_2: "Martes",
      weekday_3: "Miércoles",
      weekday_4: "Jueves",
      weekday_5: "Viernes",
      weekday_6: "Sábado",
      weekday_7: "Domingo",
      error_required: "Elige el día y escribe las dos horas.",
      error_end_not_after_start:
        "La hora final debe ser después de la inicial.",
      error_overlap: "Ese bloque se cruza con otro que ya elegiste ese día.",
      note: "Nada se impone: tú eliges. Fuera de tus bloques sigues conservando tus leads y solo dejas de recibir leads nuevos de forma automática.",
      saved: "Cambios guardados",
      save_error: "No se pudo guardar. Intenta de nuevo.",
    },
    // Almikia Epic EL (TASK-010): "Bitácora de asignación" and "Asignar automáticamente".
    // Almikia Epic EH (TASK-013): sales tools library and stage panel.
    salesTools: {
      nav: "Biblioteca de herramientas",
      title: "Biblioteca de herramientas",
      intro:
        "Guiones, preguntas, respuestas a objeciones y material para apoyarte en cada etapa. Úsalas cuando te sirvan.",
      filter_search: "Buscar",
      filter_kind: "Tipo",
      filter_stage: "Etapa",
      filter_project: "Proyecto",
      filter_buyer_type: "Tipo de cliente",
      all: "Todos",
      show_archived: "Mostrar archivadas",
      archived: "Archivada",
      empty: "No hay herramientas para estos filtros.",
      empty_title: "Todavía no hay herramientas",
      empty_description:
        "Aquí se reúnen guiones, preguntas y material de apoyo para cada etapa.",
      error: "No se pudieron cargar las herramientas. Intenta de nuevo.",
      open_link: "Abrir enlace",
      open_file: "Abrir archivo %{name}",
      file_error: "No se pudo abrir el archivo. Intenta de nuevo.",
      panel_title: "Herramientas para esta etapa",
      panel_library_link: "Ver toda la biblioteca",
      panel_empty: "Todavía no hay herramientas para esta etapa.",
      panel_empty_hint:
        "Las herramientas de esta etapa aparecerán aquí en cuanto se agreguen a la biblioteca.",
      // TASK-014: management of the catalogue (direccion and lead_manager).
      form: {
        new: "Nueva herramienta",
        edit: "Editar",
        archive: "Archivar",
        reactivate: "Reactivar",
        create_title: "Nueva herramienta",
        edit_title: "Editar herramienta",
        title: "Título",
        kind: "Tipo",
        kind_placeholder: "Elige un tipo",
        body: "Texto",
        video_url: "Enlace de video",
        file: "Archivo (opcional)",
        file_current:
          "Archivo actual: %{name}. Si subes otro, el anterior se conserva.",
        file_hint: "PDF, PNG o JPEG, de hasta 10 MB.",
        stages: "Etapas",
        projects: "Proyectos",
        buyer_types: "Tipos de cliente",
        applies_to_all: "Aplica a todos",
        save: "Guardar",
        cancel: "Cancelar",
        saved: "Herramienta guardada",
        save_error: "No se pudo guardar. Intenta de nuevo.",
        errors: {
          title_required: "Escribe un título.",
          kind_required: "Elige un tipo.",
          content_required: "Agrega un texto, un enlace o un archivo.",
          video_url_invalid: "El enlace debe empezar con http:// o https://.",
          file_not_allowed:
            "Este tipo de herramienta es solo texto y no lleva archivo.",
          invalid_type: "El archivo debe ser PDF, PNG o JPEG.",
          too_large: "El archivo supera el límite de 10 MB.",
          upload_failed:
            "No se pudo subir el archivo y la herramienta no se guardó. Revisa el archivo e intenta de nuevo.",
        },
      },
      kinds: {
        script: "Guion",
        question: "Pregunta",
        objection: "Respuesta a objeción",
        video: "Video",
        brochure: "Brochure",
        comparison: "Comparativo",
        fact_sheet: "Ficha técnica",
      },
    },
    // Almikia Epic EQ (TASK-018): "Planes de pago" admin and the lead's "Cotizador".
    // Almikia Epic E6 (TASK-039): labels of the invoicing statuses and value sets
    // (the screens add their own keys under this namespace).
    invoicing: {
      status: {
        receivable: {
          pendiente_vobo: "Pendiente de VoBo",
          por_facturar: "Por facturar",
          facturada: "Facturada",
          cobrada: "Cobrada",
          cancelada: "Cancelada",
        },
        payable: {
          pendiente_vobo: "Pendiente de VoBo",
          por_pagar: "Por pagar",
          pagada: "Pagada",
          cancelada: "Cancelada",
        },
      },
      payee_role: {
        asesora: "Asesora",
        vendedora: "Vendedora",
        opcionadora: "Aportadora del inmueble",
        colega: "Colega",
      },
      payer_type: {
        developer: "Desarrolladora",
        client: "Cliente comprador",
      },
      basis: {
        bpo_scheme: "Esquema BPO",
        colega_fixed: "Colega (tarifa fija)",
        corretaje_split: "Reparto de corretaje",
      },
      level: {
        entrenamiento: "Entrenamiento",
        junior: "Junior",
        senior: "Senior",
        elite: "Élite",
        team_leader: "Team Leader",
      },
      // TASK-040: "Pendientes de VoBo" and "Cuentas por cobrar" screens.
      error: "No se pudieron cargar los datos. Inténtalo de nuevo.",
      fields: {
        operation: "Operación",
        project: "Proyecto",
        unit: "Unidad",
        client: "Cliente",
        advisor: "Asesora",
        payer: "Paga",
        payee: "Beneficiaria",
        installment: "Parcialidad",
        installment_n: "Parcialidad %{n}",
        commission_pct: "Comisión (%)",
        amount: "Monto (antes de IVA)",
        subtotal: "Subtotal",
        iva: "IVA (%{pct}%)",
        iva_amount: "IVA",
        total: "Total",
        status: "Estado",
        sale_value: "Valor de la venta",
        invoice_folio: "Folio de factura",
        collected_at: "Fecha de cobro",
        cancel_reason: "Motivo de cancelación",
        project_or_address: "Proyecto o inmueble",
        basis: "Esquema",
        level: "Nivel",
        rate: "Tasa",
        accumulated_sales: "Ventas acumuladas",
      },
      vobo: {
        nav: "Pendientes de VoBo",
        title: "Pendientes de VoBo",
        subtitle: "Cuentas por cobrar y por pagar que esperan tu visto bueno.",
        tab_receivables: "Por cobrar",
        tab_payables: "Por pagar",
        empty_receivables: "No hay cuentas por cobrar pendientes de VoBo",
        empty_payables: "No hay cuentas por pagar pendientes de VoBo",
        last_rejection: "Último motivo de rechazo: %{reason}",
        approve: "Aprobar",
        reject: "Rechazar",
        reject_receivable_title: "Rechazar cuenta por cobrar",
        reject_payable_title: "Rechazar cuenta por pagar",
        done: {
          approved: "VoBo aprobado",
          rejected: "Rechazo registrado",
        },
      },
      approve: {
        title: "Aprobar cuenta por cobrar",
        description:
          "Revisa los datos de la operación %{operation}. Al aprobar, el concepto queda congelado.",
        concept_label: "Concepto de la factura",
        concept_hint:
          "Las ventas de corretaje no tienen plantilla: escribe el concepto. Puedes usar {N}, {PCT}, {UNIT}, {CLIENT}, {ADVISOR} y {PROJECT}.",
        preview: "Concepto que se congelará",
        confirm: "Aprobar VoBo",
        pct_source: {
          agreement: "El porcentaje viene del convenio del proyecto (%{pct}%).",
          edited: "Porcentaje distinto al convenio, capturado en el VoBo.",
          entered: "Porcentaje capturado en el VoBo.",
        },
        errors: {
          installment: "Indica un número de parcialidad válido.",
          pct: "Indica un porcentaje de comisión entre 0 y 100.",
          amount: "Indica un monto mayor a cero con máximo dos decimales.",
          template: "El proyecto no tiene plantilla de concepto disponible.",
          concept: "Escribe el concepto de la factura.",
        },
      },
      receivables: {
        totals: "Totales por estado",
        status_filter: "Filtrar por estado",
        search: "Buscar por operación, proyecto o cliente",
        invoice_title: "Marcar como facturada",
        invoice_description: "Captura el folio de la factura emitida.",
        invoice_folio: "Folio de la factura",
        mark_invoiced: "Marcar como facturada",
        mark_collected: "Marcar como cobrada",
        reject: "Rechazar",
        reject_title: "Rechazar cuenta por cobrar",
        reject_to: "La cuenta regresa al estado: %{status}.",
        final_note:
          "Para corregir una cuenta cobrada/pagada se usará un ajuste.",
        done: {
          invoiced: "Cuenta marcada como facturada",
          collected: "Cuenta marcada como cobrada",
          rejected: "Rechazo registrado",
        },
        concept_title: "Concepto de la factura",
        concept_pending:
          "El concepto se congela cuando Dirección aprueba el VoBo.",
        copy_concept: "Copiar concepto",
        copied: "Copiado",
        concept_copied: "Concepto copiado",
        concept_copy_error: "No se pudo copiar el concepto",
      },
      // TASK-041: "Cuentas por pagar" / "Mis pagos".
      payables: {
        my_title: "Mis pagos",
        advisor_invoice_notice:
          "Tu pago se genera cuando tú subes tu factura. Si Administración la sube por ti, el pago no se genera.",
        status_filter: "Filtrar por estado",
        search: "Buscar por operación, beneficiaria o proyecto",
        mark_paid: "Marcar como pagada",
        reject: "Rechazar",
        reject_title: "Rechazar cuenta por pagar",
        reject_to: "La cuenta regresa al estado: %{status}.",
        final_note:
          "Para corregir una cuenta cobrada/pagada se usará un ajuste.",
        paid_title: "Marcar como pagada",
        paid_description:
          "Indica la fecha de pago y, si la tienes, la referencia.",
        paid_on: "Fecha de pago",
        reference: "Referencia del pago",
        receivable_info:
          "Cuenta por cobrar vinculada: %{status}. Es solo informativo, no bloquea el pago.",
        done: {
          paid: "Cuenta marcada como pagada",
          rejected: "Rechazo registrado",
        },
      },
    },
    // TASK-041: invoicing settings of a project (direccion).
    projects: {
      invoicing: {
        title: "Facturación del proyecto",
        commission_label: "Comisión de la desarrolladora (%)",
        commission_save: "Guardar comisión",
        commission_hint:
          "Porcentaje que se propone al aprobar el VoBo de una cuenta por cobrar.",
        commission_saved: "Comisión actualizada",
        template_label: "Plantilla de concepto de factura",
        template_save: "Guardar nueva versión",
        template_saved: "Plantilla actualizada",
        placeholders_help:
          "Puedes usar estos marcadores: %{placeholders}. Se reemplazan al aprobar el VoBo.",
        frozen_warning:
          "Las facturas ya emitidas conservan su texto; el cambio aplica a las próximas.",
        version_n: "versión %{n}",
        history_title: "Historial de versiones",
      },
    },
    operations: {
      search: "Buscar por id o folio",
      error: "No se pudo completar la acción",
      id_copied: "Id copiado",
      open_lead: "Abrir lead",
      open_client: "Abrir cliente",
      client_registered: "Cliente registrado",
      no_client: "Sin cliente vinculado",
      choose_advisor: "Elige una asesora",
      folio_preview: "Folio que se generará:",
      expediente_guard: {
        title: "Expediente de los compradores",
        loading: "Revisando los expedientes…",
        error: "No pudimos revisar los expedientes. Inténtalo de nuevo.",
        retry: "Reintentar",
        no_contact:
          "Vincula al contacto comprador al lead antes de cerrar la operación",
        complete: "Expediente completo",
        incomplete: "Falta completar el expediente",
        missing: "Falta:",
        open: "Abrir el expediente",
      },
      admin_title: "Datos administrativos",
      documents: {
        title: "Documentos",
        loading: "Cargando documentos…",
        error: "No se pudieron cargar los documentos.",
        empty: "Todavía no hay documentos en esta operación.",
        empty_hint:
          "Aquí aparecerán los documentos del expediente en cuanto se suban.",
        empty_hint_write:
          "Usa el botón «Subir documento» para agregar el primero.",
        upload: "Subir documento",
        upload_new_version: "Subir nueva versión",
        upload_title: "Subir documento",
        upload_hint:
          "Se guarda como pendiente hasta que administración lo valide.",
        doc_type: "Tipo de documento",
        title_optional: "Título (opcional)",
        file: "Archivo",
        submit_upload: "Subir",
        uploaded: "Documento subido",
        version: "Versión %{number}",
        uploaded_by: "Subido por %{name} el %{date}",
        reviewed_by: "Revisado por %{name} el %{date}",
        validated_by: "Dictaminado por %{name} el %{date}",
        reason: "Motivo",
        reason_required: "Indica el motivo",
        download: "Descargar",
        download_error: "No se pudo generar el enlace de descarga",
        review: "Revisar",
        validate: "Validar",
        observe: "Observar",
        reject: "Rechazar",
        delete: "Eliminar",
        confirm: "Confirmar",
        cancel: "Cancelar",
        observe_title: "Observar versión",
        reject_title: "Rechazar versión",
        delete_title: "Eliminar documento",
        delete_hint:
          "El documento se oculta, pero se conserva su historial. No se borra ningún archivo.",
        review_done: "Versión marcada como revisada",
        validate_done: "Versión validada",
        observe_done: "Versión observada",
        reject_done: "Versión rechazada",
        delete_done: "Documento eliminado",
        delete_retention_hint:
          "No se puede eliminar antes del fin de su retención (%{date})",
        action_error: "No se pudo completar la acción",
        advisor_hint:
          "Un rol de administración validará tu archivo; tú no puedes validar documentos de tu propia operación.",
        payable_hint: {
          title: "Requisitos para generar la cuenta por pagar",
          green_file_yes: "Expediente en verde: sí",
          green_file_no: "Expediente en verde: no",
          invoice_yes: "Factura de la asesora subida: sí",
          invoice_no: "Factura de la asesora subida: no",
        },
        show_deleted: "Ver eliminados",
        hide_deleted: "Ocultar eliminados",
        deleted: "Eliminado",
        deleted_reason: "Motivo de eliminación: %{reason}",
        types: {
          identificacion: "Identificación",
          comprobante_domicilio: "Comprobante de domicilio",
          constancia_fiscal: "Constancia fiscal",
          contrato: "Contrato",
          apartado: "Apartado",
          pld: "PLD",
          otro: "Otro",
          factura_asesora: "Factura de la asesora",
        },
        result: {
          pendiente: "Pendiente",
          validado: "Validado",
          observado: "Observado",
          rechazado: "Rechazado",
        },
      },
      audit: {
        title: "Historial",
        loading: "Cargando historial…",
        error: "No se pudo cargar el historial.",
        empty: "Todavía no hay movimientos registrados.",
        empty_hint:
          "Cada cambio de esta operación quedará registrado aquí, con quién lo hizo y cuándo.",
        load_more: "Ver más movimientos",
        unknown_actor: "Sistema",
        old_value: "antes",
        new_value: "ahora",
        reason: "Motivo: %{reason}",
        tables: {
          operations: "Operación",
          documents: "Documento",
          document_versions: "Versión de documento",
          units: "Unidad",
          receivables: "Cuenta por cobrar",
          payables: "Cuenta por pagar",
        },
        actions: {
          insert: "Alta",
          update: "Cambio",
          delete: "Baja",
        },
        columns: {
          sale_value: "Valor de venta",
          commercial_status: "Estado comercial",
          administrative_status: "Estado administrativo",
          semaphore: "Semáforo",
          sales_id: "Asesora",
          result: "Resultado",
          reviewed_at: "Revisado el",
          validated_at: "Dictaminado el",
          deleted_at: "Eliminado el",
          id: "Id",
          deal_id: "Negocio",
          reservation_id: "Reservación",
          unit_id: "Unidad",
          project_id: "Proyecto",
          client_id: "Cliente",
          lead_type: "Tipo de lead",
          operation_type: "Tipo de operación",
          contract_folio: "Folio de contrato",
          signed_on: "Firmado el",
          cancelled_at: "Cancelado el",
          cancelled_by: "Cancelado por",
          created_by: "Creado por",
          created_at: "Creado el",
          operation_id: "Operación",
          document_id: "Documento",
          doc_type: "Tipo de documento",
          retention_until: "Conservar hasta",
          deleted_by: "Eliminado por",
          delete_reason: "Motivo de eliminación",
          version_number: "Número de versión",
          mime_type: "Tipo de archivo",
          size_bytes: "Tamaño (bytes)",
          sha256: "Huella SHA-256",
          uploaded_by: "Subido por",
          uploaded_at: "Subido el",
          reviewed_by: "Revisado por",
          validated_by: "Dictaminado por",
          advisor_at_validation: "Asesora al dictaminar",
        },
      },
      history_title: "Historial de asesoras",
      history_empty: "Todavía no hay cambios de asesora.",
      history_entry: "Asignada a %{advisor} por %{author}",
      lead_card_title: "Operaciones del lead",
      filters: {
        project: "Proyecto",
        commercial_status: "Estado comercial",
        administrative_status: "Estado administrativo",
        semaphore: "Semáforo",
        advisor: "Asesora",
      },
      fields: {
        id: "Id",
        project: "Proyecto",
        unit: "Unidad",
        advisor: "Asesora",
        new_advisor: "Nueva asesora",
        commercial_status: "Estado comercial",
        administrative_status: "Estado administrativo",
        semaphore: "Semáforo",
        semaphore_reason: "Motivo del semáforo",
        operation_type: "Tipo de operación",
        sale_value: "Valor de venta",
        folio: "Folio",
        signed_on: "Fecha de firma",
        cancel_reason: "Motivo de cancelación",
        reason: "Motivo",
        lead: "Lead",
        client: "Cliente",
        project_or_option: "Proyecto / opción",
      },
      commercial_status: {
        apartada: "Apartada",
        cerrada: "Cerrada",
        cancelada: "Cancelada",
      },
      administrative_status: {
        pendiente: "Pendiente",
        en_revision: "En revisión",
        observado: "Observado",
        validado: "Validado",
      },
      semaphore: {
        verde: "Verde",
        amarillo: "Amarillo",
        naranja: "Naranja",
        rojo: "Rojo",
      },
      type: {
        propia: "Propia",
        inter_bpo: "Inter BPO",
        intercorretaje: "Intercorretaje",
        codigo_azul: "Código Azul",
      },
      actions: {
        sign: "Firmar operación",
        sign_corretaje: "Cerrar operación",
        cancel: "Cancelar operación",
        change_advisor: "Cambiar asesora",
        copy_id: "Copiar id",
        save: "Guardar cambios",
      },
      confirm: {
        back: "Volver",
        accept: "Confirmar",
        sign: {
          title: "¿Firmar esta operación?",
          description:
            "Se guardará la fecha de firma y se generará el folio, que ya no se podrá cambiar. La unidad pasará a vendida.",
        },
        cancel: {
          title: "¿Cancelar esta operación?",
          description:
            "La operación se conserva en la lista como cancelada y el apartado de la unidad se libera. Indica el motivo.",
        },
        sign_corretaje: {
          title: "¿Cerrar esta operación?",
          description:
            "Se guardará la fecha de cierre y la opción quedará vendida. No se genera folio de contrato.",
        },
        cancel_corretaje: {
          title: "¿Cancelar esta operación?",
          description:
            "La operación se conserva en la lista como cancelada y la opción volverá a disponible. Indica el motivo.",
        },
        advisor: {
          title: "¿Cambiar la asesora de esta operación?",
          description:
            "La nueva asesora verá la operación y el cambio queda en el historial con su motivo.",
        },
      },
      done: {
        sign: "Operación firmada",
        sign_corretaje: "Operación cerrada",
        cancel_corretaje: "Operación cancelada",
        cancel: "Operación cancelada",
        advisor: "Asesora cambiada",
        admin: "Datos guardados",
      },
    },
    quoter: {
      // Almikia batch EQ3 (TASK-114): approval of custom ("a la medida") plans.
      approval: {
        pending: "Pendiente de aprobación",
        approved: "Aprobada",
        rejected: "Rechazada",
        pending_help:
          "Este plan a la medida no se puede compartir, imprimir ni mostrar al cliente hasta que sea aprobado.",
        rejected_help:
          "Este plan a la medida fue rechazado: %{comment}. Crea otra cotización con otro plan.",
        list_title: "Planes por aprobar",
        empty: "No hay planes por aprobar.",
        approve: "Aprobar",
        reject: "Rechazar",
        reject_comment_label: "Motivo del rechazo",
        reject_comment_required: "Escribe el motivo del rechazo",
        approved_toast: "Plan aprobado",
        rejected_toast: "Plan rechazado",
        notice_requested:
          "Hay un plan a la medida por aprobar (cotización #%{id})",
        notice_approved: "Tu plan a la medida fue aprobado (cotización #%{id})",
        notice_rejected:
          "Tu plan a la medida fue rechazado (cotización #%{id}): %{comment}",
        approvers_title: "Persona aprobadora de planes a la medida",
        approvers_help:
          "Solo ella (y Dirección) puede aprobar o rechazar un plan a la medida. Si la persona que cotiza es aprobadora, su plan se aprueba solo.",
        approver_add: "Agregar persona aprobadora",
        approver_active: "Activa",
        approver_inactive: "Inactiva",
        no_approver_warning:
          "No hay una persona aprobadora activa: los planes a la medida se quedan pendientes de aprobación.",
        no_approver_title: "Sin aprobador activo",
        custom_note:
          "Un plan a la medida necesita aprobación antes de compartirse. Si eres persona aprobadora, se aprueba al guardar.",
        created_pending:
          "Cotización guardada. El plan a la medida quedó pendiente de aprobación.",
        created_approved:
          "Cotización guardada. El plan a la medida quedó aprobado.",
        list_error: "No se pudieron cargar los planes por aprobar",
        requested_by: "Solicitó: %{name}",
        client_unit: "%{client} · unidad %{unit}",
        plan_summary:
          "Enganche %{down}% · Mensualidades %{monthly}% en %{months} meses · Escritura %{deed}% · Descuento %{discount}%",
        age_today: "Hoy",
        age_days: "Hace %{days} días",
        notices_to_approve: "Tienes %{count} plan(es) a la medida por aprobar",
        notices_open: "Ver planes por aprobar",
        notice_dismiss: "Entendido",
        approver_pick: "Persona",
        approver_pick_placeholder: "Elige a la persona",
        approver_activate: "Activar",
        approver_deactivate: "Desactivar",
        approver_none: "Todavía no hay personas aprobadoras.",
        action_error: "No se pudo completar la acción",
      },
      // Almikia Epic EQ (TASK-019): the public client quote page.
      public: {
        brand: "Almikia",
        greeting: "Hola, %{name}",
        intro: "Esta es tu cotización.",
        price: "Precio",
        valid_until: "Vigente hasta el %{date}",
        save_pdf: "Guardar como PDF",
        unavailable:
          "Este enlace ya no esta disponible. Pide a tu asesora uno nuevo.",
        load_error: "No pudimos cargar la cotización. Intenta de nuevo.",
        // Epic EQ2 (TASK-101): the two-sheet public quote.
        prepared_for: "Preparada especialmente para",
        plan_intro:
          "Tres formas de hacer suya esta residencia, al día y al peso.",
        share_whatsapp: "Enviar por WhatsApp",
        sheet: {
          folio: "Cotización #%{folio}",
          issued: "Emitida el %{date}",
          valid: "Vigencia: %{date}",
          page: "HOJA %{page} · 2",
          advisor: "Tu asesora",
          advisor_promise:
            "Te acompaño de esta cotización a la entrega de tu unidad.",
          whatsapp: "WhatsApp",
          qr_label: "Código QR para escribir por WhatsApp a tu asesora",
          qr_caption: "Escanee y hablamos",
          residence: "La residencia",
          model: "Modelo",
          program: "Programa",
          per_floor: "Por nivel",
          garage: "Cochera",
          construction: "Construcción total",
          unit: "La unidad",
          key: "Clave",
          block: "Manzana",
          stage: "Etapa",
          street: "Calle",
          surface: "Superficie",
          measures: "Medidas",
          excess_land: "Terreno excedente",
          orientation: "Orientación del frente",
          investment: "La inversión",
          list_price: "Precio de lista %{list}",
          excess_price: "Terreno excedente · %{m2}",
          roof: "Roof garden",
          roof_included: "Roof garden · incluido",
          extras: "Extras",
          discount: "Descuento %{scheme}",
          final_price: "Precio final",
          models: "Los modelos · lista %{list}",
          from: "Desde",
          scarcity:
            "Quedan %{in_stage} en su etapa · %{in_development} en el desarrollo",
          scarcity_development: "Quedan %{in_development} en el desarrollo",
          footer:
            "Precios en pesos mexicanos, sujetos a cambio al vencimiento de esta cotización o al cambio de lista de precios por avance de ventas, lo que ocurra primero. El apartado de %{apartado} se aplica al precio. Esta cotización no constituye un contrato.",
          plan_for: "Plan de pagos · %{name}",
          plan_note:
            "Todos los planes inician con un apartado de %{apartado} (se aplica al precio) y firma de contrato a más tardar el %{date}, fecha de vencimiento de esta cotización. La escrituración se realiza al concluir el plan de pagos.",
          includes_discount: "Incluye %{pct}% de descuento",
          list_price_only: "Precio de lista",
          date: "Fecha",
          total: "TOTAL",
        },
        wa: {
          qr_message:
            "Hola %{advisor}, le escribo por la cotización %{folio} de Almikia.",
          intro: "Hola %{name}, le comparto su cotización %{folio} de ALMIKIA:",
          unit: "• %{model} — Unidad %{unit}",
          unit_typed: "• %{model} — Unidad %{unit} (%{lotType})",
          construction: "%{m2} m² de construcción",
          surface: "lote de %{m2} m²",
          roof: "• Con roof garden",
          price: "• Precio: %{price} — %{scheme}",
          valid: "• Vigencia: %{date}",
          closing: "Quedo a sus órdenes.",
        },
      },
      title: "Cotizador",
      empty: "Este lead todavía no tiene cotizaciones.",
      empty_hint: "Las cotizaciones de este lead aparecerán aquí.",
      empty_hint_write: "Crea la primera con el formulario de abajo.",
      error: "No se pudieron cargar las cotizaciones. Intenta de nuevo.",
      action_error: "No se pudo completar la acción. Intenta de nuevo.",
      new_quote: "Nueva cotización",
      project: "Proyecto",
      pick_project: "Elige un proyecto para ver sus unidades.",
      unit: "Unidad",
      units_error: "No se pudieron cargar las unidades. Intenta de nuevo.",
      units_empty: "Este proyecto no tiene unidades.",
      more_units: "Ver más unidades",
      no_price: "Sin precio de lista",
      plan: "Plan de pago",
      plan_placeholder: "Elige un plan",
      plans_empty: "Este proyecto no tiene planes de pago activos.",
      client_first_name: "Nombre del cliente",
      client_label: "Cliente: %{name}",
      save_quote: "Guardar cotización",
      show_schedule: "Ver plan de pagos",
      link_until: "Enlace vigente hasta el %{date}",
      link_revoked: "Enlace revocado",
      link_none: "Sin enlace para compartir",
      link_copied: "Enlace copiado",
      link_revoked_done: "Enlace revocado",
      reserve: "Apartar unidad",
      release: "Liberar apartado",
      cancel_quote: "Cancelar cotización",
      copy_link: "Copiar enlace",
      revoke_link: "Revocar enlace",
      reserve_blocked_compliance:
        "No se puede apartar: el paquete de cumplimiento del proyecto está pendiente.",
      confirm: {
        reserve: "¿Apartar la unidad %{unit}?",
        release: "¿Liberar el apartado de la unidad %{unit}?",
        release_warning:
          "Si hay una operación abierta para este apartado, se cancelará.",
        cancel: "¿Cancelar esta cotización? Se conserva en la lista.",
        sell: "¿Vender la unidad %{unit}?",
        sell_warning:
          "Se marca la unidad como vendida y se cancelan las demás cotizaciones de esta unidad.",
        back: "Volver",
        accept: "Confirmar",
      },
      builder: {
        scheme: "Esquema de pago",
        scheme_placeholder: "Elige un esquema",
        schemes_empty: "Este proyecto no tiene esquemas de pago activos.",
        custom: "Plan a la medida",
        custom_down: "Enganche (%)",
        custom_monthly: "Mensualidades (%)",
        custom_deed: "Contra escritura (%)",
        custom_months: "Meses",
        custom_discount: "Descuento (%)",
        roof_add: "Agregar techo (%{price})",
        roof_line: "Techo",
        included: "Incluido",
        unit_filter: "Buscar unidad",
        unit_filter_empty: "Ninguna unidad coincide con la búsqueda.",
        units_none: "Este proyecto no tiene unidades.",
        no_model: "Sin modelo",
        stage: "Etapa %{stage}",
        blocked: "Bloqueada",
        unavailable: "No disponible",
        unverified: "Por verificar",
        unverified_warning:
          "Esta unidad está por verificar: Dirección aún no confirma su disponibilidad ni su precio. Puedes cotizarla, pero avisa al cliente.",
        preview_title: "Vista previa",
        preview_pick: "Elige una unidad y un esquema para ver el precio.",
        preview_error: "No se pudo calcular la cotización. Intenta de nuevo.",
        list: "Lista %{list}",
        base: "Precio base",
        excess: "Excedente (%{m2} m²)",
        extras: "Extras",
        gross: "Precio de lista",
        discount: "Descuento (%{pct}%)",
        final: "Precio final",
        apartado: "Apartado",
        down: "Enganche a la firma",
        installments: "%{count} mensualidades de",
        deed: "Contra escritura (mes %{month})",
        valid_until: "Vigente hasta el %{date}",
        scarcity_stage:
          "Quedan %{stage} en su etapa / %{total} en el desarrollo",
        scarcity_development: "Quedan %{total} en el desarrollo",
        calendar: "Calendario de pagos",
        models_title: "Modelos en la lista vigente",
        from: "Desde %{price}",
        state_valid: "Vigente",
        state_expired: "Vencida",
        expired_hint:
          "Esta cotización venció. Reexpídela al precio de la lista vigente para apartar o vender.",
        sell: "Vender",
        reissue: "Reexpedir",
        reissued_up:
          "Reexpedida en la lista %{list}: el precio subió %{amount}.",
        reissued_down:
          "Reexpedida en la lista %{list}: el precio bajó %{amount}.",
        reissued_same: "Reexpedida en la lista %{list}: el precio no cambió.",
        sold_done: "Unidad vendida",
      },
      quote_status: {
        activa: "Activa",
        cancelada: "Cancelada",
        convertida: "Convertida en venta",
      },
      unit_status: {
        disponible: "Disponible",
        apartada: "Apartada",
        vendida: "Vendida",
      },
      unit_types: { depto: "Departamento", local: "Local", lote: "Lote" },
      schedule: {
        title: "Plan de pagos",
        concept: "Concepto",
        when: "Cuándo",
        amount: "Monto",
        at_signing: "A la firma",
        at_end: "A la entrega",
        month: "Mes %{month}",
      },
      concepts: {
        enganche: "Enganche",
        mensualidad: "Mensualidad",
        diferido: "Pago diferido",
        entrega: "Pago contra entrega",
        credito: "Crédito",
      },
      planTypes: {
        enganche_mensualidades: "Enganche y mensualidades",
        diferido: "Diferido",
        contra_entrega: "Contra entrega",
        credito: "Crédito",
      },
      templates: {
        nav: "Planes de pago",
        title: "Planes de pago",
        new: "Nueva plantilla",
        intro:
          "Plantillas de plan de pago por proyecto. Las asesoras las usan para cotizar; nada se elimina, solo se archiva.",
        show_archived: "Mostrar archivadas",
        error: "No se pudieron cargar los planes. Intenta de nuevo.",
        empty: "No hay planes de pago para mostrar.",
        archived: "Archivada",
        edit: "Editar",
        archive: "Archivar",
        reactivate: "Reactivar",
      },
      templateForm: {
        create_title: "Nueva plantilla de plan",
        edit_title: "Editar plantilla de plan",
        project: "Proyecto",
        project_placeholder: "Elige un proyecto",
        name: "Nombre",
        plan_type: "Tipo de plan",
        plan_type_placeholder: "Elige un tipo",
        percentages: "Porcentajes y número de pagos",
        fields: {
          down_payment_pct: "Enganche (%)",
          down_payment_count: "Pagos de enganche",
          monthly_payments_pct: "Mensualidades (%)",
          monthly_payments_count: "Número de mensualidades",
          deferred_payments_pct: "Pagos diferidos (%)",
          deferred_payments_count: "Número de pagos diferidos",
          delivery_pct: "Contra entrega (%)",
          credit_pct: "Crédito (%)",
          discount_pct: "Descuento (%, opcional)",
        },
        errors: {
          project_required: "Elige un proyecto.",
          name_required: "Escribe un nombre.",
          plan_type_required: "Elige un tipo de plan.",
          pct_invalid: "Escribe un porcentaje entre 0 y 100.",
          count_invalid: "Escribe un número entero de 0 o más.",
          count_required: "Indica al menos un pago para este porcentaje.",
          sum_not_100: "Los porcentajes deben sumar 100.",
        },
        preview: "Vista previa para %{amount} MXN",
        preview_empty: "Completa el plan para ver la vista previa.",
        cancel: "Cancelar",
        save: "Guardar",
        saved: "Plan guardado",
        save_error: "No se pudo guardar. Intenta de nuevo.",
      },
      // Almikia Epic EQ2 (TASK-099): Direccion configuration screens.
      config: {
        nav: "Cotizador",
        title: "Configuración del cotizador",
        project: "Proyecto",
        sections: "Secciones de la configuración",
        section_config: "Configuración",
        section_lists: "Listas de precios",
        section_catalogue: "Modelos y esquemas",
        section_verify: "Verificar unidades",
        config_intro:
          "Estos datos aplican a todas las cotizaciones nuevas del proyecto.",
        fields: {
          apartado_amount: "Monto del apartado ($)",
          apartado_days: "Días del apartado",
          quote_validity_days: "Días de vigencia de la cotización",
          term_months: "Plazo de mensualidades (meses)",
          excess_price_per_m2: "Precio del excedente por m² ($)",
          client_protection_days: "Días de protección del cliente",
          released_stages: "Etapas liberadas (separadas por coma)",
          apartados_count_toward_list:
            "Los apartados cuentan para cambiar de lista",
        },
        save: "Guardar",
        saved: "Cambios guardados",
        save_error: "No se pudo guardar. Intenta de nuevo.",
        cancel: "Cancelar",
        edit: "Editar",
        archive: "Archivar",
        reactivate: "Reactivar",
        archived: "Archivado",
        load_error: "No pudimos cargar la configuración. Intenta de nuevo.",
        no_projects: "Todavía no hay proyectos con cotizador.",
        no_projects_hint:
          "Cuando un proyecto tenga su configuración del cotizador, aparecerá aquí.",
        errors: {
          amount_invalid: "Escribe un monto de 0 o más.",
          days_invalid: "Escribe un número entero de días, de 0 o más.",
          term_invalid: "Escribe un plazo entero entre 1 y 36 meses.",
          stages_invalid:
            "Escribe números de etapa enteros separados por coma, por ejemplo 1, 2.",
          block_invalid: "Escribe un número entero de ventas, de 1 o más.",
          pct_invalid: "Escribe un porcentaje entre 0 y 100.",
          price_invalid: "Escribe un precio mayor a 0.",
          captured_locked:
            "Un precio capturado se puede cambiar, pero no quitar.",
          code_invalid: "Escribe un código con letras, números o guiones.",
          name_required: "Escribe un nombre.",
          sum_not_100:
            "Enganche, mensualidades y escrituración deben sumar 100%.",
          discount_invalid: "Escribe un descuento de 0 a 99.",
        },
      },
      lists: {
        title: "Listas de precios",
        intro:
          "Cada lista tiene su propio bloque de ventas y un incremento sobre la lista anterior, o un precio capturado por modelo. El precio capturado manda sobre el incremento.",
        add: "Agregar lista",
        empty: "Todavía no hay listas de precios en este proyecto.",
        list_n: "Lista %{n}",
        reached_with: "Se alcanza con %{sales} ventas",
        block_size: "Ventas de este bloque",
        increment_pct: "Incremento sobre la lista anterior (%)",
        captured: "Precio capturado por modelo (opcional)",
        captured_hint:
          "Déjalo vacío para usar el incremento. Un precio capturado se puede cambiar, pero no quitar.",
        save_list: "Guardar lista %{n}",
        preview: "Vista previa de precios por modelo (solo lectura)",
        model: "Modelo",
      },
      models: {
        title: "Modelos",
        new: "Nuevo modelo",
        new_title: "Nuevo modelo",
        edit_title: "Editar modelo",
        fields: {
          code: "Código",
          name: "Nombre",
          base_price: "Precio base ($)",
          roof_price: "Precio del roof garden ($)",
          m2_per_floor: "m² por piso (opcional)",
          total_construction: "Construcción total en m² (opcional)",
          program: "Programa (opcional)",
          garage: "Cochera (opcional)",
        },
      },
      schemes: {
        title: "Esquemas de pago",
        new: "Nuevo esquema",
        new_title: "Nuevo esquema de pago",
        edit_title: "Editar esquema de pago",
        summary:
          "Enganche %{down}% · Mensualidades %{monthly}% · Escrituración %{deed}% · Descuento %{discount}%",
        fields: {
          name: "Nombre",
          down_pct: "Enganche (%)",
          monthly_pct: "Mensualidades (%)",
          deed_pct: "Escrituración (%)",
          discount_pct: "Descuento (%)",
        },
      },
      impact: {
        title: "Ver impacto del cambio de plazo",
        question:
          "El plazo pasa de %{current} a %{next} meses. Revisa qué pasaría antes de confirmar.",
        valid_quotes: "Cotizaciones vigentes",
        changed_quotes: "Cotizaciones que cambian",
        total_before: "Mensualidades antes",
        total_after: "Mensualidades después",
        total_delta: "Diferencia total",
        per_quote: "Diferencia por cotización",
        none: "Ninguna cotización vigente cambia. Solo se actualiza el plazo.",
        note: "Los precios no cambian: solo el plan de mensualidades de esas cotizaciones.",
        error: "No pudimos calcular el impacto. Intenta de nuevo.",
        apply_error: "No se pudo aplicar el cambio. Nada se modificó.",
        cancel: "Cancelar y no cambiar nada",
        confirm: "Confirmar y recalcular",
      },
      verify: {
        title: "Verificar unidades",
        intro:
          "Las unidades por verificar se pueden cotizar, pero el cotizador avisa. Confírmalas una por una o varias a la vez.",
        view_pending: "Por verificar",
        view_verified: "Verificadas",
        bulk: "Verificar seleccionadas (%{count})",
        select_all: "Seleccionar todas (%{count})",
        clear: "Quitar selección",
        select_unit: "Seleccionar la unidad %{unit}",
        confirm_unit: "Confirmar la unidad %{unit}",
        confirm: "Confirmar",
        done: "Unidades verificadas",
        error: "No se pudo verificar. Intenta de nuevo.",
        load_error: "No pudimos cargar las unidades. Intenta de nuevo.",
        empty_pending: "No hay unidades por verificar.",
        empty_pending_hint:
          "Todas las unidades de este proyecto están confirmadas.",
        empty_verified: "Todavía no hay unidades verificadas.",
        empty_verified_hint:
          "Las unidades que confirmes aparecerán aquí con quién y cuándo.",
        stage: "Etapa %{stage}",
        no_stage: "Sin etapa",
        blocked: "Bloqueada",
        not_blocked: "Sin bloqueo",
        verified_by_at: "Verificada por %{name} el %{when}",
        unknown_person: "una persona del equipo",
        prev: "Anterior",
        next: "Siguiente",
        page_of: "Página %{page} de %{pages}",
      },
      panel: {
        nav: "Panel del cotizador",
        title: "Panel del cotizador",
        load_error: "No pudimos cargar el panel. Intenta de nuevo.",
        no_config: "Este proyecto no tiene configuración del cotizador.",
        no_config_hint: "Configúralo en «Configuración del cotizador».",
        current_list: "Lista vigente",
        missing_for_list: "Ventas que faltan para la lista %{list}",
        missing_last: "Ya estás en la última lista",
        available_units: "Unidades disponibles",
        counted_with_apartados:
          "Ventas y apartados que cuentan para la lista: %{count}",
        counted_sold_only: "Ventas que cuentan para la lista: %{count}",
        scarcity: "Disponibilidad por etapa",
        scarcity_empty: "No hay unidades disponibles.",
        available_count: "%{count} disponibles",
        released: "Liberada",
        not_released: "Sin liberar",
        models: "Modelos en la lista vigente",
        price_from: "Desde %{price}",
        audit_title: "Cambios de configuración",
        audit_error: "No pudimos cargar los cambios. Intenta de nuevo.",
        audit_empty: "Todavía no hay cambios de configuración registrados.",
        audit_unknown_actor: "Alguien del equipo",
        audit_action_insert: "Se agregó en %{table}",
        audit_action_update: "Se cambió en %{table}",
        audit_action_delete: "Se quitó de %{table}",
        audit_tables: {
          quoter_configs: "la configuración",
          quoter_models: "los modelos",
          quoter_price_lists: "las listas de precios",
          quoter_model_list_prices: "los precios capturados",
          quoter_schemes: "los esquemas de pago",
          quoter_unit_details: "los datos de unidades",
        },
      },
    },
    assignmentLog: {
      nav: "Bitácora de asignación",
      title: "Bitácora de asignación",
      intro:
        "Quién recibió cada lead, cuándo, por qué canal y de qué forma. Lo más reciente va primero.",
      filter_project: "Proyecto",
      filter_channel: "Canal",
      filter_from: "Desde el día",
      filter_to: "Hasta el día",
      all: "Todos",
      empty: "No hay asignaciones para mostrar.",
      empty_hint:
        "Cada vez que un lead se asigne a una asesora, quedará registrado aquí. Prueba con otro rango de fechas o quita los filtros.",
      lead: "Lead",
      unassigned: "Sin asesora disponible",
      received_by: "Recibió: %{name}",
      clave: "Clave: %{code}",
      previous_clave: "Clave de la asesora anterior: %{code}",
      channel_value: "Canal: %{channel}",
      previous: "Anterior",
      next: "Siguiente",
      method: {
        rotation: "Rotación",
        fallback_rotation: "Rotación (sin bloque disponible)",
        manual: "Manual",
      },
    },
    autoAssign: {
      button: "Asignar automáticamente",
      assigned: "Lead asignado a %{name}.",
      nobody:
        "Nadie estaba disponible en este momento. El lead sigue sin asesora.",
      error: "No se pudo asignar el lead. Intenta de nuevo.",
    },
    // Almikia Epic EL3: documented reassignment (Dirección on a protected lead, Team Leader from
    // a notice); a written reason is mandatory.
    reassign: {
      direccion_button: "Reasignar (Dirección)",
      notice_button: "Reasignar",
      title: "Reasignar lead",
      advisor_label: "Asesora",
      advisor_placeholder: "Elige una asesora",
      reason_label: "Motivo de la reasignación",
      reason_required: "Escribe el motivo de la reasignación",
      submit: "Reasignar",
      cancel: "Cancelar",
      success: "Lead reasignado a %{name}.",
      error: "No se pudo reasignar el lead. Intenta de nuevo.",
      permission_title: "Reasignación de leads protegidos",
      permission_label: "Puede reasignar leads proactivos y de colega",
      permission_help:
        "Solo Dirección cambia este permiso, y nunca en su propio perfil.",
      permission_on: "Permiso concedido.",
      permission_off: "Permiso retirado.",
      permission_error: "No se pudo cambiar el permiso. Intenta de nuevo.",
    },
    // Almikia Epic EL (TASK-008): Direccion "Asignación de leads" screen.
    leadAssignment: {
      nav: "Asignación de leads",
      title: "Asignación de leads",
      intro:
        "Decide en qué proyectos los leads nuevos se reparten solos entre las asesoras que participan.",
      project_label: "Proyecto",
      no_projects: "Aún no hay proyectos activos.",
      rule_label: "Asignar leads automáticamente",
      rule_help:
        "Si está apagado, los leads nuevos de este proyecto quedan sin asignar para el Lead Manager.",
      fallback_label: "Si nadie está disponible, rotar entre las asesoras",
      fallback_help:
        "Si está apagado, el lead queda sin asignar para el Lead Manager cuando nadie está disponible en ese momento.",
      advisors_title: "Asesoras que participan",
      advisors_help:
        "Solo aparecen las asesoras con membresía activa en el proyecto. Activa o desactiva quién recibe leads.",
      advisors_empty: "Este proyecto no tiene asesoras activas.",
      clave: "Clave %{code}",
      advisor_toggle: "Incluir a %{name} en la rotación",
      unavailable: "No disponible para recibir leads",
      blocks_chosen: "Ha elegido bloques",
      blocks_none: "Aún no ha elegido bloques",
      channels_title: "Canales",
      channels_help:
        "Los canales son las vías por las que llegan los leads. Puedes activar, desactivar o agregar canales.",
      channel_active: "Activo",
      channel_inactive: "Inactivo",
      channel_toggle: "Canal %{label} activo",
      meta_note: "Se activa cuando se conecte la integración con Meta",
      add_channel_title: "Agregar un canal",
      channel_label: "Nombre del canal",
      channel_code: "Código del canal",
      add_channel: "Agregar canal",
      channel_error_label_required: "Escribe el nombre del canal.",
      channel_error_code_required: "Escribe un código con letras o números.",
      channel_error_duplicate: "Ya existe un canal con ese código.",
      saved: "Cambios guardados",
      save_error: "No se pudo guardar. Intenta de nuevo.",
    },
    aiUsage: {
      nav: "Uso de IA",
      title: "Uso de IA",
      spend_label: "Gasto estimado este mes",
      spend_of_cap: "%{spent} de %{cap}",
      remaining: "Quedan %{remaining} este mes",
      estimate_note:
        "El costo es una estimación a partir de los tokens usados y los precios configurados.",
      cap_reached:
        "Se alcanzó el límite del mes: las nuevas solicitudes de IA están en pausa hasta el próximo mes o hasta que subas el límite.",
      cap_label: "Límite mensual (USD)",
      cap_invalid: "Escribe un número mayor que cero.",
      cap_saved: "Límite mensual guardado",
      cap_error: "No se pudo guardar el límite. Intenta de nuevo.",
      per_action_title: "Este mes por acción",
      history_title: "Historial por mes",
      history_row:
        "%{cost} · %{calls} llamada · %{tokens} tokens |||| %{cost} · %{calls} llamadas · %{tokens} tokens",
      calls_tokens:
        "%{calls} llamada · %{tokens} tokens |||| %{calls} llamadas · %{tokens} tokens",
      recent_title: "Últimas llamadas",
      no_usage: "Todavía no hay uso de IA.",
      no_usage_hint:
        "Las llamadas al copiloto y su costo aparecerán aquí en cuanto alguien lo use.",
      actions: {
        note_suggestions: "Sugerencias de nota",
        suggest_message: "Sugerir mensaje",
        whats_missing: "¿Qué me falta?",
      },
      statuses: {
        ok: "Correcta",
        rejected_cap: "Rechazada por límite",
        error: "Error",
      },
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importación completa. Se importaron %{importCount} registros, con %{errorCount} errores",
      complete_unmatched_sources:
        "Importación completa. Se importaron %{importCount} registros, con %{errorCount} errores. %{smart_count} origen no coincide con un origen activo y se guardó solo como texto |||| Importación completa. Se importaron %{importCount} registros, con %{errorCount} errores. %{smart_count} orígenes no coinciden con un origen activo y se guardaron solo como texto",
      csv_file: "Archivo CSV",
      error:
        "No se pudo importar este archivo; asegúrate de que sea un archivo CSV válido.",
      in_progress: "Importación en curso…",
      progress:
        "Se importaron %{importCount} / %{rowCount} registros, con %{errorCount} errores.",
      remaining_time: "Tiempo restante estimado:",
      resource: "Recurso",
      sample_download: "Descargar CSV de ejemplo",
      sample_hint:
        "Este es un archivo CSV de ejemplo que puedes usar como plantilla",
      start: "Iniciar importación",
      stop: "Detener importación",
      stopped:
        "Importación detenida. Se importaron %{importCount} registros, con %{errorCount} errores",
      title: "Importar datos",
    },
    header: {
      import_data: "Importar desde JSON",
    },
    feedback: {
      button: "Reportar un problema o sugerencia",
      title: "Reportar un problema o sugerencia",
      description:
        "Cuéntanos qué pasó o qué mejorarías. Tu comentario llega a Dirección.",
      kind_label: "Tipo",
      kind_problema: "Problema",
      kind_sugerencia: "Sugerencia",
      message_label: "Mensaje",
      message_placeholder: "Describe el problema o tu sugerencia",
      screen: "Pantalla: %{title}",
      send: "Enviar",
      sending: "Enviando...",
      cancel: "Cancelar",
      success: "Gracias, tu comentario llegó a Dirección",
      error_empty: "Escribe un mensaje antes de enviar.",
      error_too_long: "El mensaje no puede pasar de %{max} caracteres.",
      error_generic: "No pudimos enviar tu comentario. Inténtalo de nuevo.",
      screen_dashboard: "Inicio",
      screen_unknown: "Pantalla de la aplicación",
      screen_detail: "Detalle de %{name}",
      screen_create: "Nuevo: %{name}",
      screen_operation: "Operación %{code}",
    },
    pilotReports: {
      nav: "Reportes del piloto",
      title: "Reportes del piloto",
      new_badge: "%{smart_count} nuevo |||| %{smart_count} nuevos",
      status_filter: "Filtrar por estado",
      kind_filter: "Filtrar por tipo",
      status_nuevo: "Nuevo",
      status_revisado: "Revisado",
      status_resuelto: "Resuelto",
      empty: "No hay reportes",
      reviewed_by: "Revisado por %{name} el %{date}",
      note_label: "Nota de Dirección",
      save_note: "Guardar nota",
      mark_revisado: "Marcar Revisado",
      mark_resuelto: "Marcar Resuelto",
      status_saved: "Reporte actualizado",
      note_saved: "Nota guardada",
      update_error: "No pudimos actualizar el reporte. Inténtalo de nuevo.",
      previous: "Anterior",
      next: "Siguiente",
    },
    inventory_stats: {
      captures_title: "Tus captaciones este mes",
      captures_progress: "%{actual} de %{target} captaciones",
      captures_so_far:
        "%{smart_count} captación este mes |||| %{smart_count} captaciones este mes",
      captures_bar_label: "Avance de captaciones frente a tu meta",
      average_title: "Promedio de días en inventario",
      average_value: "%{smart_count} día |||| %{smart_count} días",
      average_empty: "Sin propiedades disponibles",
      truncated: "Hay demasiadas propiedades para mostrar una cifra completa",
    },
    goals: {
      title: "Metas",
      month_label: "Mes",
      section_advisor: "Metas por asesora",
      section_team: "Metas de equipo (Líder BPO)",
      no_goal: "Sin meta definida",
      empty_title: "Todavía no hay a quién ponerle una meta",
      empty_description:
        "Ninguna asesora ni Líder BPO está dentro de tu alcance por ahora.",
      fields: {
        target_units: "Meta de unidades",
        target_amount_mxn: "Meta de monto (MXN)",
        target_captures: "Captaciones al mes",
      },
      captured_this_month:
        "%{smart_count} captada este mes |||| %{smart_count} captadas este mes",
      action: {
        save: "Guardar",
      },
      save_success: "Meta guardada",
      error: {
        invalid_target: "Escribe un número entero de 0 o más",
        save_denied: "No tienes permiso para guardar esta meta.",
        save_failed: "No se pudo guardar la meta. Inténtalo de nuevo.",
      },
    },
    my_progress: {
      title: "Mi avance",
      month_bar_summary:
        "Queda %{smart_count} día |||| Quedan %{smart_count} días",
      goal_title: "Tu meta del mes",
      no_goal: "Sin meta definida para este mes",
      units_and_amount: "%{units} ventas directas · %{amount}",
      units_label: "Unidades",
      units_progress: "%{actual} de %{target} unidades",
      units_bar_label: "Avance de unidades contra tu meta",
      amount_label: "Monto (MXN)",
      amount_progress: "%{actual} de %{target}",
      amount_bar_label: "Avance de monto contra tu meta",
      empty_title: "Todavía no tienes movimientos este mes",
      empty_description:
        "En cuanto registres una venta directa, tu avance aparece aquí.",
      explanation:
        "Cada mes y cada trimestre empiezan en cero: nada se acumula del periodo anterior, y solo cuentan tus ventas directas (las de tus colegas no).",
      program: {
        monthly_sale_incentive: {
          title: "Incentivo mensual por venta",
          sales_count:
            "%{smart_count} venta directa este mes |||| %{smart_count} ventas directas este mes",
        },
        quarterly_outstanding_sales: {
          title: "Ventas destacadas del trimestre",
          tier_reached: "Nivel alcanzado: %{rate}% de comisión",
          missing: "Te faltan %{units} unidades / %{amount}",
          bar_label: "Avance de ventas destacadas del trimestre",
        },
        monthly_proactive_appointments: {
          title: "Citas proactivas del mes",
          count: "%{count} de %{target} citas",
          bar_label: "Avance de citas proactivas",
        },
        gasoline_insurance: {
          title: "Seguro de gasolina",
          empty: "Todavía no hay información de tu seguro de gasolina.",
        },
      },
    },
    // Almikia Epic E7 (TASK-095): "Incentivos" admin form validation errors,
    // see `incentiveProgramForm.ts`.
    incentives: {
      error: {
        negative_number: "Escribe un número de 0 o más",
        valid_to_before_valid_from:
          "La fecha de fin no puede ser anterior a la fecha de inicio",
        tiers_not_ascending:
          "Los niveles deben ir en orden ascendente por umbral",
        tier_inclusive_required: "Indica si el umbral del nivel es inclusivo",
        new_valid_from_too_early:
          "La nueva vigencia debe empezar después del periodo actual",
      },
    },
    image_editor: {
      change: "Cambiar",
      drop_hint:
        "Suelta un archivo para subirlo o haz clic para seleccionarlo.",
      editable_content: "Contenido editable",
      title: "Subir y ajustar imagen",
      update_image: "Actualizar imagen",
    },
    import: {
      action: {
        download_error_report: "Descargar el reporte de errores",
        import: "Importar",
        import_another: "Importar otro archivo",
      },
      error: {
        unable: "No se pudo importar este archivo.",
      },
      idle: {
        description_1:
          "Puedes importar usuarios, empresas, contactos, notas y tareas.",
        description_2:
          "Los datos deben estar en un archivo JSON que siga este ejemplo:",
      },
      status: {
        all_success: "Todos los registros se importaron correctamente.",
        complete: "Importación completa.",
        failed: "Fallidos",
        imported: "Importados",
        in_progress: "Importación en curso, no salgas de esta página.",
        some_failed: "Algunos registros no se importaron.",
        table_caption: "Estatus de la importación",
      },
      title: "Importar desde JSON",
    },
    settings: {
      about: "Acerca de",
      companies: {
        sectors: "Sectores",
      },
      dark_mode_logo: "Logo para modo oscuro",
      deals: {
        categories: "Categorías",
        currency: "Moneda",
        pipeline_help:
          "Selecciona qué etapas de lead cuentan como parte del embudo.",
        pipeline_statuses: "Estatus del embudo",
        stages: "Etapas",
        stages_locked: "Estos estados son fijos y no se pueden editar aquí.",
        stages_manage_link: "Ir a Etapas",
        stages_readonly_note: "Dirección configura las etapas y sus criterios.",
        activities_manage_link: "Ir a Actividades",
        profile_options_manage_link: "Ir a Opciones del perfil",
      },
      light_mode_logo: "Logo para modo claro",
      notes: {
        statuses: "Estatus",
      },
      reset_defaults: "Restablecer valores predeterminados",
      save_error: "No se pudo guardar la configuración",
      saved: "Configuración guardada correctamente",
      saving: "Guardando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferencias",
      title: "Configuración",
      app_title: "Título de la app",
      sections: {
        branding: "Identidad de marca",
        admin: "Administración",
      },
      validation: {
        duplicate: "%{display_name} duplicadas: %{items}",
        in_use:
          "No se pueden eliminar %{display_name} que todavía usan algunos leads: %{items}",
        validating: "Validando…",
        entities: {
          categories: "categorías",
          stages: "etapas",
        },
      },
    },
    theme: {
      dark: "Oscuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    leadSources: {
      page_title: "Orígenes de leads",
      manage_link: "Ir a Orígenes de leads",
      add_action: "Nuevo origen",
      edit_action: "Editar",
      deactivate_action: "Desactivar",
      reactivate_action: "Reactivar",
      inactive_marker: "Inactivo",
      empty: "Todavía no hay orígenes de leads.",
      empty_description:
        "Los orígenes dicen de dónde llega cada lead, por ejemplo anuncios o referidos.",
      created_notice: "Origen creado",
      updated_notice: "Origen actualizado",
      deactivated_notice: "Origen desactivado",
      reactivated_notice: "Origen reactivado",
      confirm_deactivate_title: "¿Desactivar este origen?",
      confirm_deactivate_body:
        "El origen deja de ofrecerse en los leads nuevos. Los leads que ya lo tienen lo conservan.",
      confirm_reactivate_title: "¿Reactivar este origen?",
      confirm_reactivate_body:
        "El origen vuelve a estar disponible para los leads nuevos.",
    },
    // Almikia Epic E9 (TASK-049): "Leads de Meta" (solo direccion).
    metaLeads: {
      title: "Leads de Meta",
      manage_link: "Ir a Leads de Meta",
      back: "Volver a Ajustes",
      intro:
        "Webhooks recibidos de Meta Lead Ads y qué pasó con cada lead. Los más recientes primero.",
      status_title: "Webhooks recibidos",
      filter_result: "Resultado",
      all: "Todos",
      empty: "Todavía no se ha recibido ningún webhook.",
      empty_hint:
        "Cuando Meta envíe un lead nuevo, verás aquí qué pasó con él.",
      lead: "Lead",
      unclassified: "Sin clasificar",
      previous: "Anterior",
      next: "Siguiente",
      result: {
        received: "Recibido",
        rejected_signature: "Rechazado: firma inválida",
        processed: "Procesado",
        ignored: "Ignorado",
        error: "Error",
      },
      signature: { valid: "Firma válida", invalid: "Firma inválida" },
      project_choice: {
        form_mapping: "Proyecto del formulario",
        none: "Sin proyecto",
        not_sellable: "Proyecto no vendible",
      },
      assignment: {
        assigned: "Asignado",
        no_candidates: "Sin candidatos: queda para el Lead Manager",
        skipped: "Sin asignar",
        rule_disabled: "Asignación desactivada",
      },
      mapping: {
        title: "Formularios de Meta y proyectos",
        intro:
          "Cada id de formulario de Meta envía sus leads a un proyecto. Solo se ofrecen proyectos vendibles.",
        empty: "Todavía no hay formularios asignados.",
        add_action: "Agregar formulario",
        change_action: "Cambiar proyecto",
        choose_project: "Elige un proyecto",
        created_notice: "Formulario agregado",
        updated_notice: "Proyecto actualizado",
      },
      mapping_format_help:
        "Un token por línea: form:<id>, campaign:<id> o ad:<id>. Si varios orígenes coinciden, gana el anuncio, luego la campaña y luego el formulario.",
    },
    // Almikia Epic EM (TASK-067): origen Meta de un lead, reporte de campañas y eventos Meta.
    metaOrigin: {
      title: "Origen Meta",
      no_origin: "Sin origen Meta",
      platform: { facebook: "Facebook", instagram: "Instagram" },
      lookup_status: {
        pendiente: "Pendiente de consultar",
        ok: "Consultado",
        sin_anuncio: "Sin anuncio",
      },
      fields: {
        campaign: "Campaña",
        adset: "Conjunto de anuncios",
        ad: "Anuncio",
        ad_title: "Título del anuncio",
        platform: "Plataforma",
        ctwa_clid: "ctwa_clid",
        first_contact_at: "Primer contacto",
        lookup_status: "Consulta del anuncio",
      },
      lookup_action: "Consultar anuncio",
      lookup_pending_action: "Consultar pendientes",
      lookup_done: "Anuncio consultado",
      ctwa_save_action: "Guardar ctwa_clid",
      ctwa_saved: "ctwa_clid guardado",
      retry_action: "Reintentar consulta",
      lookup_failed:
        "No se pudo consultar el anuncio. Inténtalo de nuevo más tarde.",
      load_error: "No se pudo cargar el origen Meta",
      ids_summary: "Identificadores",
      ids: {
        ad_id: "ID del anuncio",
        campaign_id: "ID de la campaña",
        adset_id: "ID del conjunto",
        leadgen_id: "ID del formulario (leadgen)",
      },
      ctwa_input_label: "Registrar ctwa_clid a mano",
      ctwa_required: "Escribe el ctwa_clid",
      ctwa_too_long: "El ctwa_clid es demasiado largo",
      ctwa_invalid:
        "El ctwa_clid solo admite letras, números, guiones y guion bajo",
      ctwa_unchanged: "Ese ctwa_clid ya estaba registrado",
      ctwa_failed: "No se pudo guardar el ctwa_clid",
      report: {
        title: "Reporte de campañas Meta",
        export_action: "Exportar CSV",
        empty: "No hay leads de Meta en este rango de fechas.",
        export_denied: "Tu rol no puede exportar este reporte",
        nav: "Reportes por campaña",
        error: "No se pudo cargar el reporte",
        platform_filter: "Plataforma",
        platform_all: "Todas",
        range_from: "Desde",
        range_to: "Hasta",
        group_by: "Agrupar por",
        group: {
          campaign: "Campaña",
          adset: "Conjunto de anuncios",
          ad: "Anuncio",
        },
        headers: {
          campaign: "Campaña",
          adset: "Conjunto de anuncios",
          ad: "Anuncio",
          platform: "Plataforma",
          leads: "Leads",
          qualified_leads: "Leads calificados",
          appointments: "Citas",
          reservations: "Apartados",
          sales: "Ventas",
          sale_value: "Valor de ventas",
          qualified_rate: "% calificados",
          appointment_rate: "% citas",
          sales_rate: "% ventas",
          median_first_response: "Primera respuesta (mediana, min)",
        },
      },
      events: {
        title: "Eventos Meta",
        empty: "No hay eventos para estos filtros.",
        retry_action: "Reintentar",
        retry_done: "Evento en cola para reintento",
        process_pending_action: "Procesar pendientes",
        process_pending_done: "Eventos pendientes procesados",
        process_pending_result: "Eventos enviados: %{count}",
        manage_link: "Ir a Eventos Meta",
        filter_all: "Todos",
        load_error: "No se pudieron cargar los eventos",
        action_error: "No se pudo completar la acción. Inténtalo de nuevo.",
        config_missing_title: "Sin configuración",
        config_missing_body:
          "El último intento de envío reportó que falta la configuración de la integración con Meta. Los eventos quedan pendientes hasta que el dueño la complete.",
        log: {
          show: "Ver intentos",
          hide: "Ocultar intentos",
          empty: "Este evento aún no tiene intentos.",
          error: "No se pudo cargar el registro de intentos",
          attempt: "Intento %{number}",
          http_status: "Código HTTP",
          response: "Respuesta",
          error_label: "Error",
        },
        filter_status: "Estado",
        filter_event: "Evento",
        filter_from: "Desde",
        filter_to: "Hasta",
        headers: {
          lead: "Lead",
          event: "Evento",
          status: "Estado",
          attempts: "Intentos",
          event_time: "Fecha del evento",
          last_attempt: "Último intento",
          next_attempt: "Próximo intento",
          last_error: "Último error",
          value: "Valor",
        },
        name: {
          lead_calificado: "Lead calificado",
          cita: "Cita",
          compra: "Compra",
        },
        status: {
          pending: "Pendiente",
          sent: "Enviado",
          failed: "Fallido",
          abandoned: "Abandonado",
        },
        log_status: {
          sent: "Enviado",
          failed: "Fallido",
          abandoned: "Abandonado",
          sin_configuracion: "Sin configuración",
          reintento: "Reintento",
        },
      },
    },
    // Almikia Epic EC (TASK-030) / EC2d (TASK-137): "Inventario Almikia" (opciones, exclusivas y unidades BPO).
    opciones: {
      search: "Buscar por dirección",
      filters: {
        status: "Estado",
        zone: "Zona",
        type: "Tipo",
        responsable: "Responsable",
        panel: "Filtros",
        clear: "Quitar filtros",
        origin: "Origen",
        operation: "Operación",
        furnished: "Amueblado",
        price_min: "Precio mínimo",
        price_max: "Precio máximo",
        area_min: "m² mínimos",
        area_max: "m² máximos",
        levels_min: "Niveles (mínimo)",
        bedrooms_min: "Recámaras (mínimo)",
        bathrooms_min: "Baños (mínimo)",
        parking_min: "Estacionamientos (mínimo)",
      },
      origin: {
        opcion: "Opción",
        exclusiva: "Exclusiva",
        bpo: "BPO",
      },
      operation: {
        venta: "Venta",
        renta: "Renta",
      },
      furnished: {
        amueblado: "Amueblado",
        sin_amueblar: "Sin amueblar",
      },
      specs: {
        levels: "%{value} niv.",
        bedrooms: "%{value} rec.",
        bathrooms: "%{value} baños",
        area_m2: "%{value} m²",
        parking: "%{value} est.",
      },
      choose_furnished: "Elige si es amueblada",
      status: {
        disponible: "Disponible",
        apartada: "Apartada",
        vendida: "Vendida",
        retirada: "Retirada",
      },
      type: {
        casa: "Casa",
        departamento: "Departamento",
        terreno: "Terreno",
        local: "Local",
        oficina: "Oficina",
        rancho: "Rancho",
        bodega: "Bodega",
        lote_habitacional: "Lote habitacional",
        lote_comercial: "Lote comercial",
        lote_industrial: "Lote industrial",
        otro: "Otro",
      },
      actions: {
        disponible: "Marcar disponible",
        apartada: "Marcar apartada",
        vendida: "Marcar vendida",
        retirada: "Retirar",
      },
      edit_action: "Editar",
      create_title: "Nueva propiedad del Inventario Almikia",
      edit_title: "Editar propiedad del Inventario Almikia",
      choose_type: "Elige el tipo",
      choose_responsable: "Elige la responsable",
      owner_title: "Contacto del propietario",
      owner_form_hint:
        "Solo lo ven Dirección, la coordinación y la responsable de la opción.",
      owner_private: "Los datos del propietario son privados.",
      owner_empty: "Todavía no hay contacto del propietario registrado.",
      created_notice: "Propiedad registrada",
      updated_notice: "Propiedad actualizada",
      status_changed_notice: "Estado de la propiedad actualizado",
      // Almikia Epic EC2d (TASK-138): promotion checklist of a property.
      promotion: {
        title: "Promoción",
        lona_placed: "Lona colocada",
        lona_kind: "Tipo de lona",
        se_vende: "Se vende",
        se_renta: "Se renta",
        photos_professional: "Fotos profesionales",
        video: "Video",
        virtual_tour: "Recorrido virtual",
        published_portals: "Publicada en portales",
        portals: "Portales",
        portals_required: "Elige al menos un portal",
        published_social: "Publicada en redes sociales",
        ficha_ready: "Ficha lista",
        saved: "Guardado",
        yes: "Sí",
        no: "No",
      },
    },
    // Almikia Epic EC2d (TASK-138): Direccion-only property types catalogue admin.
    propertyTypes: {
      page_title: "Tipos de propiedad",
      list_title: "Catálogo de tipos",
      manage_link: "Ir a Tipos de propiedad",
    },
    // Almikia Epic EC (TASK-032): corretaje sale administration, split and Direccion VoBo.
    corretaje: {
      fields: {
        option: "Opción",
      },
      sale: {
        title: "Administración de la venta",
        choose: "Elige una opción",
        yes: "Sí",
        no: "No",
        shared: "¿Venta compartida con colega?",
        found_by: "¿Quién consiguió al colega?",
        found_by_options: {
          asesora_proactiva: "La asesora (proactiva)",
          lead_manager: "Asignado por Lead Manager",
          direccion_corretaje: "Asignado por Dirección de Corretaje",
        },
        property_owner: "¿De quién es el inmueble?",
        property_owner_options: {
          almikia: "Nuestro inventario",
          colega: "Del colega",
        },
        opcionadora: "Opcionadora",
        opcionadora_vendedora: "%{name} (la vendedora)",
        vendedora: "Vendedora",
        commission_total: "Comisión total",
        save: "Guardar administración",
        saved: "Administración de la venta guardada",
        error: "No se pudo cargar la administración de la venta",
        locked_note:
          "La venta tiene el VoBo de Dirección y ya no se puede editar.",
        read_only_note:
          "Solo puedes ver esta venta. La editan Administración, Dirección y la coordinación.",
        split_title: "Reparto de la comisión",
        case: "Caso %{code}",
        split_empty: "Captura la comisión total para ver el reparto.",
        split_unavailable: "El reparto no está disponible para tu rol.",
        split_snapshot: "Reparto congelado con el VoBo de Dirección.",
        parties: {
          colega: "Colega",
          vendedora: "Vendedora",
          opcionadora: "Opcionadora",
          almikia: "Almikia",
        },
      },
      vobo: {
        title: "VoBo de Dirección",
        status: {
          pendiente: "VoBo pendiente",
          solicitado: "VoBo solicitado",
          aprobado: "VoBo aprobado",
          observado: "VoBo observado",
        },
        decided: "Decidido por %{name} el %{date}",
        requested: "Solicitado el %{date}",
        note: "Nota",
        ready: "Lista para solicitar el VoBo",
        missing: "Falta algo: %{fields}",
        missing_fields: {
          shared: "si se comparte con colega",
          colega: "el colega",
          found_by: "quién consiguió al colega",
          vendedora_clave: "la clave de la vendedora",
          commission_total: "la comisión total",
        },
        request: "Solicitar VoBo",
        approve: "Aprobar",
        observe: "Observar",
        reopen: "Reabrir",
        confirm: "Confirmar",
        note_for: {
          observado: "¿Qué debe corregirse?",
          reopen: "¿Por qué se reabre la venta?",
        },
        done: {
          requested: "VoBo solicitado",
          aprobado: "VoBo aprobado",
          observado: "VoBo observado",
          reopen: "Venta reabierta",
        },
        later_phase_note:
          "Contabilidad toma la venta desde aquí en una fase posterior.",
      },
      sell: {
        action: "Vender esta opción",
        title: "Vender esta opción",
        description:
          "Elige el lead comprador. La opción %{address} pasará a apartada.",
        lead: "Lead comprador",
        choose: "Elige un lead",
        no_leads: "No hay leads disponibles para vender esta opción.",
        confirm: "Crear operación",
        created: "Operación de corretaje creada",
      },
    },
    colegas: {
      page_title: "Colegas",
      manage_link: "Ir a Colegas",
      add_action: "Nuevo colega",
      edit_action: "Editar",
      deactivate_action: "Desactivar",
      reactivate_action: "Reactivar",
      inactive_marker: "Inactivo",
      search_placeholder: "Buscar por nombre, teléfono o inmobiliaria",
      empty: "Todavía no hay colegas registrados.",
      empty_description:
        "Aquí se registran los colegas externos que te refieren leads.",
      no_match: "Ningún colega coincide con tu búsqueda.",
      picker_placeholder: "Elige un colega",
      create_action: "Crear colega",
      restricted: "Colega registrado",
      created_notice: "Colega registrado",
      updated_notice: "Colega actualizado",
      deactivated_notice: "Colega desactivado",
      reactivated_notice: "Colega reactivado",
      confirm_deactivate_title: "¿Desactivar este colega?",
      confirm_deactivate_body:
        "El colega deja de ofrecerse en los leads nuevos. Los leads que ya lo tienen lo conservan.",
      confirm_reactivate_title: "¿Reactivar este colega?",
      confirm_reactivate_body:
        "El colega vuelve a estar disponible para los leads nuevos.",
    },
    // Almikia Epic EG (TASK-044): pantallas de Gastos.
    expenses: {
      new: "Nuevo gasto",
      edit_title: "Editar gasto",
      back_to_detail: "Volver al gasto",
      back_to_list: "Volver a Gastos",
      totals: {
        link: "Totales mensuales",
        title: "Totales mensuales",
        excludes_cancelled: "No incluye gastos cancelados",
        amount: "Cantidad (MXN)",
        iva: "IVA",
        count: "Gastos",
        total_amount: "Total del mes",
        total_iva: "IVA del mes",
        total_count: "Número de gastos",
        by_category: "Por categoría",
        by_paid_by: "Por quién pagó",
        empty: "Aún no hay gastos para mostrar totales",
        error: "No se pudieron cargar los totales. Inténtalo de nuevo.",
      },
      reimbursement: {
        link: "Por reembolsar al socio",
        title: "Por reembolsar al socio",
        subtitle:
          "Gastos vigentes pagados por Pepe Díaz, el único socio con reembolso.",
        pending_total: "Total pendiente de reembolso",
        pending_section: "Pendientes",
        done_section: "Reembolsados",
        empty_pending: "No hay gastos pendientes de reembolso",
        empty_done: "Aún no hay gastos reembolsados",
        error: "No se pudieron cargar los gastos. Inténtalo de nuevo.",
        reimbursed_on: "Reembolsado el",
        mark: "Marcar como reembolsado",
        unmark: "Deshacer reembolso",
        mark_selected:
          "Marcar como reembolsado (%{smart_count}) |||| Marcar como reembolsados (%{smart_count})",
        unmark_selected: "Deshacer reembolso (%{smart_count})",
        select_all: "Seleccionar todos",
        select_row: "Seleccionar %{concept}",
        dialog_title:
          "Marcar como reembolsado |||| Marcar %{smart_count} gastos como reembolsados",
        dialog_description:
          "Indica la fecha en que se reembolsó. No puede ser una fecha futura.",
        date: "Fecha del reembolso",
        confirm: "Confirmar reembolso",
        marked:
          "Gasto marcado como reembolsado |||| Gastos marcados como reembolsados",
        unmarked: "Reembolso deshecho",
      },
      search: "Concepto o proveedor",
      total_label: "Total de esta vista (sin cancelados)",
      active: "Vigente",
      cancelled: "Cancelado",
      invoiced_yes: "Facturado",
      invoiced_no: "Sin factura",
      pending_reimbursement: "Pendiente de reembolso",
      reimbursed: "Reembolsado el %{date}",
      choose_category: "Elige una categoría",
      no_project: "Sin proyecto (gasto general)",
      iva_preview: "IVA incluido (%{pct}%): %{amount}",
      created_notice: "Gasto registrado",
      updated_notice: "Gasto actualizado",
      save_error: "No se pudo guardar el gasto. Inténtalo de nuevo.",
      filters: {
        month: "Mes",
        category: "Categoría",
        paid_by: "Pagado por",
        invoiced: "Facturado",
        all: "Todos",
        yes: "Sí",
        no: "No",
      },
      fields: {
        date: "Fecha",
        concept: "Concepto",
        category: "Categoría",
        supplier: "Proveedor",
        amount: "Cantidad (MXN)",
        subtotal: "Subtotal",
        iva: "IVA",
        has_iva: "Lleva IVA",
        invoiced: "Facturado",
        invoiced_switch: "Se facturó",
        cfdi_uuid: "UUID del CFDI",
        cfdi_pdf: "CFDI en PDF",
        cfdi_xml: "CFDI en XML",
        paid_by: "Pagado por",
        paid_by_other: "Nombre de quien pagó",
        payment_method: "Forma de pago",
        project: "Proyecto / centro de costo",
        notes: "Notas",
        receipt: "Comprobante",
        status: "Estado",
      },
      paid_by_values: {
        sibaris: "Sibaris",
        pepe_diaz: "Pepe Díaz",
        otro: "Otro",
      },
      payment_methods: {
        efectivo: "Efectivo",
        transferencia: "Transferencia",
        tarjeta: "Tarjeta",
        otro: "Otro",
      },
      files: {
        upload: "Subir archivo",
        replace: "Reemplazar archivo",
        open: "Abrir",
        attached: "Archivo adjunto",
        none: "Sin archivo",
        open_error: "No se pudo abrir el archivo",
        error_invalid_type: "Ese tipo de archivo no se acepta",
        error_too_large: "El archivo supera el límite de 10 MB",
        error_upload: "No se pudo subir el archivo",
      },
      cancel: {
        action: "Cancelar gasto",
        title: "Cancelar gasto",
        description:
          "El gasto se queda en la lista como Cancelado y deja de contar en los totales. No se puede deshacer.",
        reason: "Motivo de la cancelación",
        back: "Volver",
        confirm: "Confirmar cancelación",
        done: "Gasto cancelado",
        info: "Cancelado el %{date}. Motivo: %{reason}",
      },
      categories: {
        link: "Categorías de gastos",
        page_title: "Categorías de gastos",
        name_field: "Nombre de la categoría",
        add_action: "Agregar categoría",
        edit_action: "Renombrar",
        archive_action: "Archivar",
        reactivate_action: "Reactivar",
        archived_marker: "Archivada",
        empty: "Aún no hay categorías",
        read_only: "Solo Dirección puede cambiar las categorías.",
        created_notice: "Categoría creada",
        updated_notice: "Categoría actualizada",
        archived_notice: "Categoría archivada",
        reactivated_notice: "Categoría reactivada",
        confirm_archive_title: "Archivar categoría",
        confirm_archive_body:
          "Ya no se ofrecerá para gastos nuevos. Los gastos anteriores la conservan.",
        confirm_reactivate_title: "Reactivar categoría",
        confirm_reactivate_body: "Se volverá a ofrecer para gastos nuevos.",
      },
    },
    profileOptions: {
      page_title: "Opciones del perfil",
      label_field: "Nombre de la opción",
      add_action: "Agregar opción",
      edit_action: "Editar",
      archive_action: "Archivar",
      reactivate_action: "Reactivar",
      archived_marker: "Archivada",
      empty: "Todavía no hay opciones en este catálogo.",
      created_notice: "Opción creada",
      updated_notice: "Opción actualizada",
      archived_notice: "Opción archivada",
      reactivated_notice: "Opción reactivada",
      confirm_archive_title: "¿Archivar esta opción?",
      confirm_archive_body:
        "La opción deja de ofrecerse para nuevas selecciones. Los leads que ya la tienen la conservan, marcada como archivada.",
      confirm_reactivate_title: "¿Reactivar esta opción?",
      confirm_reactivate_body:
        "La opción vuelve a estar disponible para nuevas selecciones.",
    },
    navigation: {
      label: "Navegación del CRM",
      more: "Más",
    },
    profile: {
      add_secondary_email: "Agregar un correo",
      advisor_code_taken: "Esta clave de asesora ya la usa otra persona",
      advisor_code_reserved:
        "Esta clave de asesora está reservada y no se puede asignar",
      advisor_code_note:
        "Dirección o tu Lead Manager pueden actualizar tu clave de asesora.",
      no_advisor_code: "Aún no la agregas",
      email_taken: "%{email} ya lo usa otro usuario",
      no_secondary_emails: "Ninguno",
      secondary_email_invalid: "%{email} no es un correo electrónico válido",
      secondary_email_is_primary: "%{email} ya es tu correo principal",
      secondary_email_taken: "%{email} ya lo usa otro usuario",
      too_many_secondary_emails:
        "No puedes agregar más de 10 correos secundarios",
      secondary_emails_help:
        "Otras direcciones desde las que envías correos. Deja una vacía para eliminarla.",
      inbound: {
        description:
          "Puedes empezar a enviar correos a la dirección de correo entrante de tu servidor, por ejemplo agregándola al campo %{field}. Almikia CRM procesará los correos y agregará notas a los contactos correspondientes.",
        title: "Correo entrante",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Usa esta URL para conectar tu asistente de IA a los datos de tu CRM mediante el Model Context Protocol (MCP).",
      },
      password: {
        change: "Cambiar contraseña",
      },
      password_reset_sent:
        "Te enviamos un correo para restablecer tu contraseña",
      record_not_found: "Registro no encontrado",
      title: "Perfil",
      updated: "Tu perfil se actualizó",
      update_error: "Ocurrió un error. Inténtalo de nuevo",
    },
    validation: {
      invalid_url: "Debe ser una URL válida",
      invalid_linkedin_url: "La URL debe ser de linkedin.com",
      invalid_rfc:
        "El RFC debe tener 12 o 13 caracteres alfanuméricos en mayúsculas",
      invalid_fiscal_zip_code: "El código postal fiscal debe tener 5 dígitos",
      invalid_curp: "El CURP debe tener 18 caracteres alfanuméricos",
      curp_not_allowed_persona_moral: "El CURP no aplica para persona moral",
      future_birthday: "La fecha de nacimiento no puede ser futura",
      invalid_children_count:
        "El número de hijos debe ser un entero mayor o igual a 0",
      marital_regime_required:
        "El régimen matrimonial es obligatorio cuando el estado civil es casado",
    },
  },
} satisfies CrmMessages;
